export const userPlacements = [
    {
      "sort_order": 1,
      "user_details": {
        "name": "Karthik V",
        "linkedin_url": "https://www.linkedin.com/in/karthikvels/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Vjbwwws1t9Z0ljhm2m6drC-Pf3s/P16zjQ../1605015867066.jpg"
      },
      "company_details": {
        "id": 618,
        "created_at": 1726027889708,
        "name_alias": "Samsung R&D Institute India",
        "company_link": "https://research.samsung.com/sri-b",
        "company_name": "Samsung R&D Institute India",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/bmYsxuuZ-TwfoCplJotYGsjDRgw/HmmqPg../samsungrndindiabangalore_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "samsungrndindiabangalore_logo.jpeg",
          "path": "/vault/OXY-0ZPV/bmYsxuuZ-TwfoCplJotYGsjDRgw/HmmqPg../samsungrndindiabangalore_logo.jpeg",
          "size": 5802,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Chief Engineer",
      "skill_companies_id": 618
    },
    {
      "sort_order": 2,
      "user_details": {
        "name": "Aarti J.",
        "linkedin_url": "https://www.linkedin.com/in/aarti-j-60b426164/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/4H3A65eL1xD-AVpsMH2r1lrzgz0/mNYOhQ../1724855610745.jpg"
      },
      "company_details": {
        "id": 404,
        "created_at": 1683364664058,
        "name_alias": "",
        "company_link": "https://on.tcs.com/2R5UDOp",
        "company_name": "Tata Consultancy Services",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ayv3lk6CWhbZ0durCu_Q1R-HTLo/vhv4Sg../1656657976685.jpg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1656657976685.jpg",
          "path": "/vault/OXY-0ZPV/ayv3lk6CWhbZ0durCu_Q1R-HTLo/vhv4Sg../1656657976685.jpg",
          "size": 9177,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Design Analyst",
      "skill_companies_id": 404
    },
    {
      "sort_order": 3,
      "user_details": {
        "name": "Vellala Lalitha Somanath",
        "linkedin_url": "https://www.linkedin.com/in/vellala-somanath-5b801942/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/DwFnr2e-rPRm8fMAAaB5kDt6lFM/QGlJOg../1696764623094.jpg"
      },
      "company_details": {
        "id": 44,
        "created_at": 1661986542077,
        "name_alias": "alias name needed",
        "company_link": "https://www.techmahindra.com/",
        "company_name": "Tech Mahindra",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/d2-0kbPrCPPN4jR_HqJuK7fi1gI/PKpRTA../tech_mahindra_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "tech_mahindra_logo.jpeg",
          "path": "/vault/OXY-0ZPV/d2-0kbPrCPPN4jR_HqJuK7fi1gI/PKpRTA../tech_mahindra_logo.jpeg",
          "size": 4131,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Analyst",
      "skill_companies_id": 44
    },
    {
      "sort_order": 4,
      "user_details": {
        "name": "Sindhuja Kathirvelu",
        "linkedin_url": "https://www.linkedin.com/in/sindhuja-kathirvelu-5743b366/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/nGVUfvcA_MuW6tUwdcwMzBwkEEY/fnEMsg../1691423509824.jpg"
      },
      "company_details": {
        "id": 54,
        "created_at": 1662185079955,
        "name_alias": "alias name needed",
        "company_link": "https://www.hcltech.com/",
        "company_name": "HCL Technologies",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/gETqlVfeVIaN6ymCGKrFbgSOpR4/oTCzOQ../hcltech_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "hcltech_logo.jpeg",
          "path": "/vault/OXY-0ZPV/gETqlVfeVIaN6ymCGKrFbgSOpR4/oTCzOQ../hcltech_logo.jpeg",
          "size": 4903,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Sr Specialist - Account Services ",
      "skill_companies_id": 54
    },
    {
      "sort_order": 5,
      "user_details": {
        "name": "Krishan Kumar",
        "linkedin_url": "https://www.linkedin.com/in/krishan-kumar-55827565/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/AjKci6mbXLsUtwKSfZLPiyQdKaE/7rCm8A../1659404706273.jpg"
      },
      "company_details": {
        "id": 597,
        "created_at": 1725882079283,
        "name_alias": "Daikin Airconditioning India Pvt. Ltd",
        "company_link": "http://www.daikinindia.com/",
        "company_name": "Daikin Airconditioning India Pvt. Ltd",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/KX2auU5UYwge8X8jjYEL9mDm_yg/oT-IWA../daikin_airconditioning_india_pvt_ltd_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "daikin_airconditioning_india_pvt_ltd_logo.jpeg",
          "path": "/vault/OXY-0ZPV/KX2auU5UYwge8X8jjYEL9mDm_yg/oT-IWA../daikin_airconditioning_india_pvt_ltd_logo.jpeg",
          "size": 4443,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Research And Development Specialist",
      "skill_companies_id": 597
    },
    {
      "sort_order": 6,
      "user_details": {
        "name": "Raghav Dubey",
        "linkedin_url": "https://www.linkedin.com/in/raghav-dubey-b374aa79/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/2KMfHp_VoYG7t-GxGKDpxZFpK1g/i6uMIA../1687356171058.jpg"
      },
      "company_details": {
        "id": 648,
        "created_at": 1726460590404,
        "name_alias": "Polycab India Limited",
        "company_link": "https://polycab.com/",
        "company_name": "Polycab India Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/cKjfb6hU4TXffLVHVg6KiBds8Ss/Sd8KTg../Screenshot%2B2024-09-16%2Bat%2B9.52.57%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.52.57â€¯AM.png",
          "path": "/vault/OXY-0ZPV/cKjfb6hU4TXffLVHVg6KiBds8Ss/Sd8KTg../Screenshot%2B2024-09-16%2Bat%2B9.52.57%E2%80%AFAM.png",
          "size": 14123,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Deputy Manager",
      "skill_companies_id": 648
    },
    {
      "sort_order": 7,
      "user_details": {
        "name": "Arpita Datta",
        "linkedin_url": "https://www.linkedin.com/in/arpita-datta-22031569/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/PwAehYfK60JP8E53l4hqtTcjia4/54pUFg../1723299825256.jpg"
      },
      "company_details": {
        "id": 543,
        "created_at": 1687586324678,
        "name_alias": "alias name needed",
        "company_link": "https://www.lenskart.com/",
        "company_name": "Lenskart",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/nLYn_TsHCYHpPFzn68JqmouqfJc/84Hnnw../lenskart_com_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "lenskart_com_logo.jpeg",
          "path": "/vault/OXY-0ZPV/nLYn_TsHCYHpPFzn68JqmouqfJc/84Hnnw../lenskart_com_logo.jpeg",
          "size": 7478,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Manager",
      "skill_companies_id": 543
    },
    {
      "sort_order": 8,
      "user_details": {
        "name": "Debjyoti Das",
        "linkedin_url": "https://www.linkedin.com/in/debjyoti-das-86840711a/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/QJtYFalTG2tz-xw-HhhKzRFbyFI/H1gExw../1621662441514.jpg"
      },
      "company_details": {
        "id": 598,
        "created_at": 1725882302488,
        "name_alias": "Axis Bank",
        "company_link": "http://www.axisbank.com",
        "company_name": "Axis Bank",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/BMCXQLd1MomvcnMyheaINbexpb4/i-VsdQ../axis_bank_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "axis_bank_logo.jpeg",
          "path": "/vault/OXY-0ZPV/BMCXQLd1MomvcnMyheaINbexpb4/i-VsdQ../axis_bank_logo.jpeg",
          "size": 3779,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Customer Service Manager",
      "skill_companies_id": 598
    },
    {
      "sort_order": 9,
      "user_details": {
        "name": "Manish Sharma",
        "linkedin_url": "https://www.linkedin.com/in/ermanish-sharma/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/RAVkcp529We9gI-paW44hyv_bng/8teDew../1702573995821.jpg"
      },
      "company_details": {
        "id": 129,
        "created_at": 1669307495178,
        "name_alias": "alias name needed",
        "company_link": "https://www.tatatechnologies.com/in/",
        "company_name": "Tata technologies",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/xB2R2aJGWiCCFs4O1Vtxd-1xpaI/hDXZ1w../tata_technologies_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "tata_technologies_logo.jpeg",
          "path": "/vault/OXY-0ZPV/xB2R2aJGWiCCFs4O1Vtxd-1xpaI/hDXZ1w../tata_technologies_logo.jpeg",
          "size": 5567,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Team Lead - Project Management",
      "skill_companies_id": 129
    },
    {
      "sort_order": 10,
      "user_details": {
        "name": "Akshay Betkar",
        "linkedin_url": "https://www.linkedin.com/in/akshay-betkar-2155263b/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/fUN1Ag0pTfVSv2hvFEbaz9twi1k/rFjgcg../1678779475810.jpg"
      },
      "company_details": {
        "id": 601,
        "created_at": 1725882761718,
        "name_alias": "SBI Capital Markets",
        "company_link": "http://www.sbicaps.com",
        "company_name": "SBI Capital Markets",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/YUuRaqwbqyYzG5ArsU74vuB1qBA/XVPETA../sbi_capital_markets_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "sbi_capital_markets_logo.jpeg",
          "path": "/vault/OXY-0ZPV/YUuRaqwbqyYzG5ArsU74vuB1qBA/XVPETA../sbi_capital_markets_logo.jpeg",
          "size": 5234,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "IT Manager",
      "skill_companies_id": 601
    }
  ,
    {
      "sort_order": 11,
      "user_details": {
        "name": "Archishman Sarkar",
        "linkedin_url": "https://www.linkedin.com/in/archishman-sarkar-641047166/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/iWSU8awCf7x_PGc68BpAoGwWaqI/TEahCA../1591713111757.jpg"
      },
      "company_details": {
        "id": 565,
        "created_at": 1688471493652,
        "name_alias": "PwC",
        "company_link": "https://www.pwc.in/",
        "company_name": "PwC",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/6S8yOhdybJrHdNHHwkKhqtELzkc/JP76oQ../pwc_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "pwc_logo.jpeg",
          "path": "/vault/OXY-0ZPV/6S8yOhdybJrHdNHHwkKhqtELzkc/JP76oQ../pwc_logo.jpeg",
          "size": 4926,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Associate",
      "skill_companies_id": 565
    },
    {
      "sort_order": 12,
      "user_details": {
        "name": "DILIP PATIDAR",
        "linkedin_url": "https://www.linkedin.com/in/dilip-patidar1993/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/R_mlUUDw9y6ufKQSgZ18U6KTfKA/Pa6Dmw../1677562913897.jpg"
      },
      "company_details": {
        "id": 442,
        "created_at": 1684397083926,
        "name_alias": "",
        "company_link": "https://www.lnthydrocarbon.com/",
        "company_name": "Larsen & Toubro",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/47nDyMx7OnodPI6lQBCtvXr1UWI/C7lSDg../image_2023-05-18_133435650.png",
          "meta": {
            "width": 151,
            "height": 142
          },
          "mime": "image/png",
          "name": "image_2023-05-18_133435650.png",
          "path": "/vault/OXY-0ZPV/47nDyMx7OnodPI6lQBCtvXr1UWI/C7lSDg../image_2023-05-18_133435650.png",
          "size": 10535,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "ASSISTANT CONSTRUCTION MANAGER- CIVIL",
      "skill_companies_id": 442
    },
    {
      "sort_order": 13,
      "user_details": {
        "name": "Shravan Bhadoria",
        "linkedin_url": "https://www.linkedin.com/in/shravan-bhadoria-5a5a56198/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/lAKTSsIANpXJh0_Yr1QpFLfdq5I/MSc6hg../1713372615689.jpg"
      },
      "company_details": {
        "id": 44,
        "created_at": 1661986542077,
        "name_alias": "alias name needed",
        "company_link": "https://www.techmahindra.com/",
        "company_name": "Tech Mahindra",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/d2-0kbPrCPPN4jR_HqJuK7fi1gI/PKpRTA../tech_mahindra_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "tech_mahindra_logo.jpeg",
          "path": "/vault/OXY-0ZPV/d2-0kbPrCPPN4jR_HqJuK7fi1gI/PKpRTA../tech_mahindra_logo.jpeg",
          "size": 4131,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Team Lead",
      "skill_companies_id": 44
    },
    {
      "sort_order": 14,
      "user_details": {
        "name": "Amit Kohli",
        "linkedin_url": "https://www.linkedin.com/in/amit-kohli-24591228/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/s-Re354-h_h4szHCrVAcgvs64fg/5HMnOg../1650783841069.jpg"
      },
      "company_details": {
        "id": 666,
        "created_at": 1730776270786,
        "name_alias": "Adani Digital Labs",
        "company_link": "https://adanidigitallabs.com/",
        "company_name": "Adani Digital Labs",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/uojcgWqTGnZc6X674E-42QFGGg4/1zZpPQ../3.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "3.jpeg",
          "path": "/vault/OXY-0ZPV/uojcgWqTGnZc6X674E-42QFGGg4/1zZpPQ../3.jpeg",
          "size": 6022,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Deputy Manager QA",
      "skill_companies_id": 666
    },
    {
      "sort_order": 15,
      "user_details": {
        "name": "Krishanu Das",
        "linkedin_url": "https://www.linkedin.com/in/krishanu-das-830782234/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/1_eCDO61V9u5btPFkhSTcRSo5f0/ctej6Q../1713377206104.jpg"
      },
      "company_details": {
        "id": 404,
        "created_at": 1683364664058,
        "name_alias": "",
        "company_link": "https://on.tcs.com/2R5UDOp",
        "company_name": "Tata Consultancy Services",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ayv3lk6CWhbZ0durCu_Q1R-HTLo/vhv4Sg../1656657976685.jpg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1656657976685.jpg",
          "path": "/vault/OXY-0ZPV/ayv3lk6CWhbZ0durCu_Q1R-HTLo/vhv4Sg../1656657976685.jpg",
          "size": 9177,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "IT Analyst",
      "skill_companies_id": 404
    },
    {
      "sort_order": 16,
      "user_details": {
        "name": "Abhijeet Satapathy",
        "linkedin_url": "https://www.linkedin.com/in/abhijeet-satapathy-49526915b/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/fDGQXgefnWEgH8bQr7xu3zWmM5I/T-poEA../1722420306784.jpg"
      },
      "company_details": {
        "id": 37,
        "created_at": 1661896022882,
        "name_alias": "alias name needed",
        "company_link": "https://www.icicicareers.com/website/",
        "company_name": "ICICI Bank",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/J9lwsw_CNi8H-_BlmONdXjPhfcU/P2CdDA../icici_bank_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "icici_bank_logo.jpeg",
          "path": "/vault/OXY-0ZPV/J9lwsw_CNi8H-_BlmONdXjPhfcU/P2CdDA../icici_bank_logo.jpeg",
          "size": 6907,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Branch Head",
      "skill_companies_id": 37
    },
    {
      "sort_order": 17,
      "user_details": {
        "name": "Vaskar Das",
        "linkedin_url": "https://www.linkedin.com/in/vaskar-das-757ab621a/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/nDkn9ZBvZjDN-6BflG9K7U9qGIk/1_-bdQ../1700983401414.jpg"
      },
      "company_details": {
        "id": 523,
        "created_at": 1687580626433,
        "name_alias": "alias name needed",
        "company_link": "https://www.mastercard.co.in/en-in.html",
        "company_name": "Mastercard",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ky0-FdaKIptUr12KcNdQ6xixX-U/KRmHEg../1631340300330.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1631340300330.jpeg",
          "path": "/vault/OXY-0ZPV/ky0-FdaKIptUr12KcNdQ6xixX-U/KRmHEg../1631340300330.jpeg",
          "size": 3569,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Implementation Specialist",
      "skill_companies_id": 523
    },
    {
      "sort_order": 18,
      "user_details": {
        "name": "Jhansi Priya Padala",
        "linkedin_url": "https://www.linkedin.com/in/jhansi-priya-padala-3b8aa9183/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/4K-yZWZpJZMhTLrZ69ch5_wlDUE/YtQDeg../1691489356624.jpg"
      },
      "company_details": {
        "id": 610,
        "created_at": 1725887495969,
        "name_alias": "Micron Technology",
        "company_link": "http://www.micron.com/",
        "company_name": "Micron Technology",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/0AzP-SmSb3JgVQmm_VqNUkXb_Xw/PpNkEQ../1689289021439.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1689289021439.jpeg",
          "path": "/vault/OXY-0ZPV/0AzP-SmSb3JgVQmm_VqNUkXb_Xw/PpNkEQ../1689289021439.jpeg",
          "size": 7111,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Validation Engineer",
      "skill_companies_id": 610
    },
    {
      "sort_order": 19,
      "user_details": {
        "name": "Rohan Budhwant",
        "linkedin_url": "https://www.linkedin.com/in/rohan-budhwant-5a9351217/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Pq2tlX-8Eqts95P-53szW66TZCE/l0IX8A../1704477479973.jpg"
      },
      "company_details": {
        "id": 37,
        "created_at": 1661896022882,
        "name_alias": "alias name needed",
        "company_link": "https://www.icicicareers.com/website/",
        "company_name": "ICICI Bank",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/J9lwsw_CNi8H-_BlmONdXjPhfcU/P2CdDA../icici_bank_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "icici_bank_logo.jpeg",
          "path": "/vault/OXY-0ZPV/J9lwsw_CNi8H-_BlmONdXjPhfcU/P2CdDA../icici_bank_logo.jpeg",
          "size": 6907,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Product Manager",
      "skill_companies_id": 37
    },
    {
      "sort_order": 20,
      "user_details": {
        "name": "Swarna Neel Majumder",
        "linkedin_url": "https://www.linkedin.com/in/swarnaneelmajumder/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/jNUBxW0RJpknlR8o35XshmA9tqg/y0OW7A../1635503824981.jpg"
      },
      "company_details": {
        "id": 404,
        "created_at": 1683364664058,
        "name_alias": "",
        "company_link": "https://on.tcs.com/2R5UDOp",
        "company_name": "Tata Consultancy Services",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ayv3lk6CWhbZ0durCu_Q1R-HTLo/vhv4Sg../1656657976685.jpg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1656657976685.jpg",
          "path": "/vault/OXY-0ZPV/ayv3lk6CWhbZ0durCu_Q1R-HTLo/vhv4Sg../1656657976685.jpg",
          "size": 9177,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Process Trainer",
      "skill_companies_id": 404
    }
    ,
    {
      "sort_order": 21,
      "user_details": {
        "name": "Darsana M.S.",
        "linkedin_url": "https://www.linkedin.com/in/darsana-m-s-43b1b511a/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/5JZwD3pSpAtpIvdXP3AjphWn9fU/iSJoPQ../1606212371402.jpg"
      },
      "company_details": {
        "id": 594,
        "created_at": 1725881669562,
        "name_alias": "THE FEDERAL BANK LIMITED",
        "company_link": "http://www.federalbank.co.in/",
        "company_name": "THE FEDERAL BANK LIMITED",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/bdqurO_0TD5eYO7iVkF5sr4tbfw/rOUnHQ../the_federal_bank_limited_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "the_federal_bank_limited_logo.jpeg",
          "path": "/vault/OXY-0ZPV/bdqurO_0TD5eYO7iVkF5sr4tbfw/rOUnHQ../the_federal_bank_limited_logo.jpeg",
          "size": 6299,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Probationary Officer",
      "skill_companies_id": 594
    },
    {
      "sort_order": 22,
      "user_details": {
        "name": "Rahul Mahapatro",
        "linkedin_url": "https://www.linkedin.com/in/rahul-mahapatro-610b11163/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/giCabXrdhMuvqGCuQKYsjM7B4ms/pVa0IA../1647856714605.jpg"
      },
      "company_details": {
        "id": 52,
        "created_at": 1662184848285,
        "name_alias": "alias name needed",
        "company_link": "https://www2.deloitte.com/global/en/careers/job-search.html",
        "company_name": "Deloitte",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ynVpvFWj2QKHNjn09VEZ3UyIn0w/SQ77kw../deloitte_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "deloitte_logo.jpeg",
          "path": "/vault/OXY-0ZPV/ynVpvFWj2QKHNjn09VEZ3UyIn0w/SQ77kw../deloitte_logo.jpeg",
          "size": 3940,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "DC Analyst ",
      "skill_companies_id": 52
    },
    {
      "sort_order": 23,
      "user_details": {
        "name": "Ramesh Narapureddi",
        "linkedin_url": "https://www.linkedin.com/in/ramesh-narapureddi-752088224/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/z4pJdE62yaDUsfVxP-27N_JX9nc/0YOLXQ../1730354683146.jpg"
      },
      "company_details": {
        "id": 404,
        "created_at": 1683364664058,
        "name_alias": "",
        "company_link": "https://on.tcs.com/2R5UDOp",
        "company_name": "Tata Consultancy Services",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ayv3lk6CWhbZ0durCu_Q1R-HTLo/vhv4Sg../1656657976685.jpg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1656657976685.jpg",
          "path": "/vault/OXY-0ZPV/ayv3lk6CWhbZ0durCu_Q1R-HTLo/vhv4Sg../1656657976685.jpg",
          "size": 9177,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "System Engineer",
      "skill_companies_id": 404
    },
    {
      "sort_order": 24,
      "user_details": {
        "name": "Arsia Naaz",
        "linkedin_url": "https://www.linkedin.com/in/arsia-naaz-345181230/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/lMJadJD33UJ4SVDTFwE3YiofPH8/zwpmnQ../1646822914170.jpg"
      },
      "company_details": {
        "id": 372,
        "created_at": 1682505212894,
        "name_alias": "Accenture",
        "company_link": "https://www.accenture.com/in-en",
        "company_name": "Accenture",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/OisJIvdiaSNOHY7aa-eWXV87PZI/ON7sVA../brc.jpg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "brc.jpg",
          "path": "/vault/OXY-0ZPV/OisJIvdiaSNOHY7aa-eWXV87PZI/ON7sVA../brc.jpg",
          "size": 4835,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Project Management Associate",
      "skill_companies_id": 372
    },
    {
      "sort_order": 25,
      "user_details": {
        "name": "Kirti Raj",
        "linkedin_url": "https://www.linkedin.com/in/kirti-r/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/_XeiIZnko68FJJSVToVpS8WaWA8/Tv9dAw../1705245223398.jpg"
      },
      "company_details": {
        "id": 590,
        "created_at": 1725880352774,
        "name_alias": "spotify nichname",
        "company_link": "https://www.photon.com/",
        "company_name": "Photon",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Ec0otC7IlitzU4VnXPh1EdxB3Ec/hWCj7w../photon_interactive_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "photon_interactive_logo.jpeg",
          "path": "/vault/OXY-0ZPV/Ec0otC7IlitzU4VnXPh1EdxB3Ec/hWCj7w../photon_interactive_logo.jpeg",
          "size": 5789,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Project AnalystProject Analyst",
      "skill_companies_id": 590
    },
    {
      "sort_order": 26,
      "user_details": {
        "name": "Sudhanshu Pandita",
        "linkedin_url": "https://www.linkedin.com/in/sudhanshu-pandita-17117221a/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/DTCixMf6FzbOroZUoZfLjSRzJ_w/TTMfnA../1710081376444.jpg"
      },
      "company_details": {
        "id": 662,
        "created_at": 1726916815953,
        "name_alias": "TATA ELXSI",
        "company_link": "http://www.tataelxsi.com/",
        "company_name": "TATA ELXSI",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/UFRI1D7k36p3-9DfhH4UBnYs_pU/JrWGgg../tataelxsi_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "tataelxsi_logo.jpeg",
          "path": "/vault/OXY-0ZPV/UFRI1D7k36p3-9DfhH4UBnYs_pU/JrWGgg../tataelxsi_logo.jpeg",
          "size": 7734,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "E&E Integration Engineer",
      "skill_companies_id": 662
    },
    {
      "sort_order": 27,
      "user_details": {
        "name": "Manoj M Pillai",
        "linkedin_url": "https://www.linkedin.com/in/manoj-m-pillai-34013a43/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Xg9onPPoXia77-duUwbw32t9q1g/iUeYgA../1652797510169.jpg"
      },
      "company_details": {
        "id": 647,
        "created_at": 1726460556125,
        "name_alias": "Conduent",
        "company_link": "https://www.conduent.com/",
        "company_name": "Conduent",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/sXfD6UjK9dAAjVMeRHD198gPgEo/DUxgqw../Screenshot%2B2024-09-16%2Bat%2B9.51.33%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.51.33â€¯AM.png",
          "path": "/vault/OXY-0ZPV/sXfD6UjK9dAAjVMeRHD198gPgEo/DUxgqw../Screenshot%2B2024-09-16%2Bat%2B9.51.33%E2%80%AFAM.png",
          "size": 19190,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Operations Manager",
      "skill_companies_id": 647
    },
    {
      "sort_order": 28,
      "user_details": {
        "name": "Vishal Devrani",
        "linkedin_url": "https://www.linkedin.com/in/vishaldevrani/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/WXk3o_wXhfvC7_8GvoIlXKsKf-E/69R7Og../1730386061182.jpg"
      },
      "company_details": {
        "id": 47,
        "created_at": 1661988815622,
        "name_alias": "alias name needed",
        "company_link": "https://www.genpact.com/careers",
        "company_name": "Genpact",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1719928740495.jpeg",
          "path": "/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "size": 5159,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Assistant Manager",
      "skill_companies_id": 47
    },
    {
      "sort_order": 29,
      "user_details": {
        "name": "Bilal Shaik",
        "linkedin_url": "https://www.linkedin.com/in/bilal-shaik-05435bab/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/QOS0jY9swxkPC3GS3hdyUM6Sy9g/5dG2hg../1517639739606.jpg"
      },
      "company_details": {
        "id": 655,
        "created_at": 1726461779917,
        "name_alias": "Bajaj Finserv",
        "company_link": "https://www.bajajfinserv.in/",
        "company_name": "Bajaj Finserv",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/VLFyGq-0pB5T9R4-pay8-elLZCE/bP-ULA../Screenshot%2B2024-09-16%2Bat%2B10.12.34%E2%80%AFAM.png",
          "meta": {
            "width": 858,
            "height": 836
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+10.12.34â€¯AM.png",
          "path": "/vault/OXY-0ZPV/VLFyGq-0pB5T9R4-pay8-elLZCE/bP-ULA../Screenshot%2B2024-09-16%2Bat%2B10.12.34%E2%80%AFAM.png",
          "size": 485608,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Cluster Manager",
      "skill_companies_id": 655
    },
    {
      "sort_order": 30,
      "user_details": {
        "name": "Virbahadur (Viru) Singh",
        "linkedin_url": "https://www.linkedin.com/in/virbahadur-singh-b9549325/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Is9Ym0R9oZfNIRiY1_vGx4KKEkY/XLPRQw../1693330472509.jpg"
      },
      "company_details": {
        "id": 642,
        "created_at": 1726459992973,
        "name_alias": "Suzlon Group",
        "company_link": "https://www.suzlon.com/",
        "company_name": "Suzlon Group",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/rz4M0iTnoXLWFKz6f8Us-AV8mF0/mNRoVA../Screenshot%2B2024-09-16%2Bat%2B9.42.59%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.42.59â€¯AM.png",
          "path": "/vault/OXY-0ZPV/rz4M0iTnoXLWFKz6f8Us-AV8mF0/mNRoVA../Screenshot%2B2024-09-16%2Bat%2B9.42.59%E2%80%AFAM.png",
          "size": 13074,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Executive - Administration ",
      "skill_companies_id": 642
    }
  ,
    {
      "sort_order": 31,
      "user_details": {
        "name": "Varun Bahirwani",
        "linkedin_url": "https://www.linkedin.com/in/varun-bahirwani-a4295b283/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/q7XT7zALb317yhjoPRv-XkbsspU/EN3rDQ../1723484788153.jpg"
      },
      "company_details": {
        "id": 44,
        "created_at": 1661986542077,
        "name_alias": "alias name needed",
        "company_link": "https://www.techmahindra.com/",
        "company_name": "Tech Mahindra",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/d2-0kbPrCPPN4jR_HqJuK7fi1gI/PKpRTA../tech_mahindra_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "tech_mahindra_logo.jpeg",
          "path": "/vault/OXY-0ZPV/d2-0kbPrCPPN4jR_HqJuK7fi1gI/PKpRTA../tech_mahindra_logo.jpeg",
          "size": 4131,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Customer Care Executive",
      "skill_companies_id": 44
    },
    {
      "sort_order": 32,
      "user_details": {
        "name": "Nikesh kumar",
        "linkedin_url": "https://www.linkedin.com/in/nikesh-kumar-a6922a193/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/H8WRLRecO8ElxZI6t8ksOgKkshI/gTFn6A../1702628272236.jpg"
      },
      "company_details": {
        "id": 658,
        "created_at": 1726462269051,
        "name_alias": "Grow Indigo",
        "company_link": "https://www.growindigo.co.in/",
        "company_name": "Grow Indigo",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/pfTfRAT2ipU5-ArZlh4Mq52GDNU/MWv_Vw../Screenshot%2B2024-09-16%2Bat%2B10.20.52%E2%80%AFAM.png",
          "meta": {
            "width": 178,
            "height": 172
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+10.20.52â€¯AM.png",
          "path": "/vault/OXY-0ZPV/pfTfRAT2ipU5-ArZlh4Mq52GDNU/MWv_Vw../Screenshot%2B2024-09-16%2Bat%2B10.20.52%E2%80%AFAM.png",
          "size": 17071,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Motion Graphic Designer",
      "skill_companies_id": 658
    },
    {
      "sort_order": 33,
      "user_details": {
        "name": "Rushikesh Purat",
        "linkedin_url": "https://www.linkedin.com/in/rushikeshpurat/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/STTgvWA3gsuf3OK-5YPPrtOE2t8/WhFOXQ../1712239370738.jpg"
      },
      "company_details": {
        "id": 8,
        "created_at": 1661201564448,
        "name_alias": "",
        "company_link": "https://www.infosys.com/careers.html",
        "company_name": "Infosys",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/1xdi3uU43anGJVBLf2dmi2-3wu0/frjuAg../Infosys_logo.svg.png",
          "meta": {
            "width": 1280,
            "height": 512
          },
          "mime": "image/png",
          "name": "Infosys_logo.svg.png",
          "path": "/vault/OXY-0ZPV/1xdi3uU43anGJVBLf2dmi2-3wu0/frjuAg../Infosys_logo.svg.png",
          "size": 46008,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior System Engineer",
      "skill_companies_id": 8
    },
    {
      "sort_order": 34,
      "user_details": {
        "name": "Ravish Sawant",
        "linkedin_url": "https://www.linkedin.com/in/ravish-sawant-18738491/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/XTLaG4IbTG90wNlyHTiZ7w71SFc/tzAfmg../1617522627281.jpg"
      },
      "company_details": {
        "id": 667,
        "created_at": 1730776352924,
        "name_alias": "Cipla",
        "company_link": "http://www.cipla.com/",
        "company_name": "Cipla",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/rPnIR8iOY1-kxagDEybDRL4FaOU/PEhJZQ../4.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "4.jpeg",
          "path": "/vault/OXY-0ZPV/rPnIR8iOY1-kxagDEybDRL4FaOU/PEhJZQ../4.jpeg",
          "size": 4568,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Deputy Manager Quality control ",
      "skill_companies_id": 667
    },
    {
      "sort_order": 35,
      "user_details": {
        "name": "Nisha Poddar",
        "linkedin_url": "https://www.linkedin.com/in/nisha-poddar-t010705712/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/o3cq_R10Nhc1aIquEEZp1XkGJ78/SoXCww../1600078285763.jpg"
      },
      "company_details": {
        "id": 643,
        "created_at": 1726460127446,
        "name_alias": "Association of Registered Tax Return Preparers (aRTRP)",
        "company_link": "https://www.linkedin.com/company/association-of-registered-tax-return-preparers-artrp-/",
        "company_name": "Association of Registered Tax Return Preparers (aRTRP)",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/91XPSVjktYWqM1IMKULIJp3-9qo/bttsoQ../Screenshot%2B2024-09-16%2Bat%2B9.45.12%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.45.12â€¯AM.png",
          "path": "/vault/OXY-0ZPV/91XPSVjktYWqM1IMKULIJp3-9qo/bttsoQ../Screenshot%2B2024-09-16%2Bat%2B9.45.12%E2%80%AFAM.png",
          "size": 12086,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Registered GST Practioner and Tax Return Preparer",
      "skill_companies_id": 643
    },
    {
      "sort_order": 36,
      "user_details": {
        "name": "Jitender Singh",
        "linkedin_url": "https://www.linkedin.com/in/jitender-singh-6a481473/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/IZZCoyaaKo9eOERMoTzdJNx6qQM/Ug6C7g../1532570828111.jpg"
      },
      "company_details": {
        "id": 620,
        "created_at": 1726312238694,
        "name_alias": "YouGov",
        "company_link": "https://today.yougov.com/",
        "company_name": "YouGov",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/W49TwroCZMGg_O1lZXjHbntFseQ/Ikb9Xg../Screenshot%2B2024-09-14%2Bat%2B4.40.17%E2%80%AFPM.png",
          "meta": {
            "width": 180,
            "height": 164
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-14+at+4.40.17â€¯PM.png",
          "path": "/vault/OXY-0ZPV/W49TwroCZMGg_O1lZXjHbntFseQ/Ikb9Xg../Screenshot%2B2024-09-14%2Bat%2B4.40.17%E2%80%AFPM.png",
          "size": 26852,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Finance Manager",
      "skill_companies_id": 620
    },
    {
      "sort_order": 37,
      "user_details": {
        "name": "Mohd Naved Siddiqui",
        "linkedin_url": "https://www.linkedin.com/in/mohd-naved-siddiqui/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/RPDeqtEKV7na-tLrsXZ-skPhVUM/2Z-FUA../1730055656697.jpg"
      },
      "company_details": {
        "id": 641,
        "created_at": 1726459885303,
        "name_alias": "Cambay Consulting LLC",
        "company_link": "https://cambaycs.com/",
        "company_name": "Cambay Consulting LLC",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/PrwR28827-VhgRqYj_6lPOGAdEE/mktDvw../Screenshot%2B2024-09-16%2Bat%2B9.40.53%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.40.53â€¯AM.png",
          "path": "/vault/OXY-0ZPV/PrwR28827-VhgRqYj_6lPOGAdEE/mktDvw../Screenshot%2B2024-09-16%2Bat%2B9.40.53%E2%80%AFAM.png",
          "size": 15587,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Manager - Procurement",
      "skill_companies_id": 641
    },
    {
      "sort_order": 38,
      "user_details": {
        "name": "Adwait Phadke",
        "linkedin_url": "https://www.linkedin.com/in/adwaitphadke/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Apz-a2fYshVjZKcd3FVX93mZE0w/rVmIXQ../1680082300628.jpg"
      },
      "company_details": {
        "id": 583,
        "created_at": 1725878879717,
        "name_alias": "spotify nichname",
        "company_link": "http://www.everestind.com/",
        "company_name": "Everest Industries Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/dpCBm6Za2CUbOy5UJm275OLf-KI/DQ-iqg../everest_industries_limited_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "everest_industries_limited_logo.jpeg",
          "path": "/vault/OXY-0ZPV/dpCBm6Za2CUbOy5UJm275OLf-KI/DQ-iqg../everest_industries_limited_logo.jpeg",
          "size": 4300,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Manager Special Project",
      "skill_companies_id": 583
    },
    {
      "sort_order": 39,
      "user_details": {
        "name": "Amit Rana",
        "linkedin_url": "https://www.linkedin.com/in/amit-rana-33753a97/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/_tbkXAJGhJtfjkWhDczj7gK60ec/Iy0Fsg../1721330111590.jpg"
      },
      "company_details": {
        "id": 623,
        "created_at": 1726312499001,
        "name_alias": "UKG",
        "company_link": "https://www.ukg.in/",
        "company_name": "UKG",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/CAh793eiCOoTg6RBx2m93FvURwQ/JJ9G8g../Screenshot%2B2024-09-14%2Bat%2B4.44.36%E2%80%AFPM.png",
          "meta": {
            "width": 180,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-14+at+4.44.36â€¯PM.png",
          "path": "/vault/OXY-0ZPV/CAh793eiCOoTg6RBx2m93FvURwQ/JJ9G8g../Screenshot%2B2024-09-14%2Bat%2B4.44.36%E2%80%AFPM.png",
          "size": 17812,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nImplementation Representative III (USA Payroll)",
      "skill_companies_id": 623
    },
    {
      "sort_order": 40,
      "user_details": {
        "name": "SHIVA KUMAR BURGUPALLY",
        "linkedin_url": "https://www.linkedin.com/in/shiva-kumar-burgupally-11812aaa/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/2l_dhcZ5wmFRXb3F4nzI3TdcWC4/wOgMTg../1640781023222.jpg"
      },
      "company_details": {
        "id": 585,
        "created_at": 1725878985931,
        "name_alias": "spotify nichname",
        "company_link": "http://www.sgd-pharma.com/",
        "company_name": "SGD Pharma",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/X_QmnaU7FyQWbRS2dt2avgURc2M/NosNUQ../sgd_na_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "sgd_na_logo.jpeg",
          "path": "/vault/OXY-0ZPV/X_QmnaU7FyQWbRS2dt2avgURc2M/NosNUQ../sgd_na_logo.jpeg",
          "size": 11415,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Sr.Executive",
      "skill_companies_id": 585
    }
  ,
    {
      "sort_order": 41,
      "user_details": {
        "name": "Arun Verma",
        "linkedin_url": "https://www.linkedin.com/in/arun-verma-6a18221ba/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/mecDyN87suIRq_XdzqbKYMTkpgU/16o3cg../1724774973015.jpg"
      },
      "company_details": {
        "id": 612,
        "created_at": 1725887977614,
        "name_alias": "RailWire",
        "company_link": "http://www.railwire.co.in/",
        "company_name": "RailWire",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/anARQUJuACCOSpAEL5v_ekmKLGM/qg_hMg../railwire_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "railwire_logo.jpeg",
          "path": "/vault/OXY-0ZPV/anARQUJuACCOSpAEL5v_ekmKLGM/qg_hMg../railwire_logo.jpeg",
          "size": 13318,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Project Manager",
      "skill_companies_id": 612
    },
    {
      "sort_order": 42,
      "user_details": {
        "name": "Sarbajit Thakur",
        "linkedin_url": "https://www.linkedin.com/in/sarbajit-thakur-5bb5278b/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/5N4jLvCefcE7UjokrtyssYBxCas/VXI7vA../1631934202174.jpg"
      },
      "company_details": {
        "id": 588,
        "created_at": 1725880102451,
        "name_alias": "spotify nichname",
        "company_link": "https://www.exotel.com/",
        "company_name": "Exotel",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/QPYWAlF0NjB6ZRoNBAz2ewR8I_A/e6hCzw../exotel_techcom_private_limited_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "exotel_techcom_private_limited_logo.jpeg",
          "path": "/vault/OXY-0ZPV/QPYWAlF0NjB6ZRoNBAz2ewR8I_A/e6hCzw../exotel_techcom_private_limited_logo.jpeg",
          "size": 3491,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Technical Program Manager",
      "skill_companies_id": 588
    },
    {
      "sort_order": 43,
      "user_details": {
        "name": "ARUSHI HANDA",
        "linkedin_url": "https://www.linkedin.com/in/arushi-handa-03679413b/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/T4-aCCXsvsXDPj_d5A1a2RGZgP0/Za5bEw../1731952560354.jpg"
      },
      "company_details": {
        "id": 616,
        "created_at": 1726027726073,
        "name_alias": "Cvent",
        "company_link": "https://www.cvent.com",
        "company_name": "Cvent",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/TP-suIwmqtfA4uCjHeiVHUZ44p0/jWxq0Q../cvent_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "cvent_logo.jpeg",
          "path": "/vault/OXY-0ZPV/TP-suIwmqtfA4uCjHeiVHUZ44p0/jWxq0Q../cvent_logo.jpeg",
          "size": 5295,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Project Consultant",
      "skill_companies_id": 616
    },
    {
      "sort_order": 44,
      "user_details": {
        "name": "Sarita Katare",
        "linkedin_url": "https://www.linkedin.com/in/sarita-katare-b6a1bb13b/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/KBI75ruLsnp4XjwLRNb35qMpIQs/EHvVqQ../1721809514617.jpg"
      },
      "company_details": {
        "id": 584,
        "created_at": 1725878941767,
        "name_alias": "spotify nichname",
        "company_link": "http://www.tessolve.com/",
        "company_name": "Tessolve",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Dm9g1snDRb_lD7QwvkRwzDtwZAk/FBGc-Q../tessolve_services_pvt_ltd_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "tessolve_services_pvt_ltd_logo.jpeg",
          "path": "/vault/OXY-0ZPV/Dm9g1snDRb_lD7QwvkRwzDtwZAk/FBGc-Q../tessolve_services_pvt_ltd_logo.jpeg",
          "size": 5814,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Marketing Manager",
      "skill_companies_id": 584
    },
    {
      "sort_order": 45,
      "user_details": {
        "name": "Dhaneshwar Patidar",
        "linkedin_url": "https://www.linkedin.com/in/dhaneshwar-patidar-2b6720165/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/zt3YCtF_-ezNnLZF78Vb1WmssEY/F9wK6w../1689107997844.jpg"
      },
      "company_details": {
        "id": 589,
        "created_at": 1725880212046,
        "name_alias": "spotify nichname",
        "company_link": "http://www.jetsynthesys.com/",
        "company_name": "JetSynthesys",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/uWD3XQY2XIGfjfFR-m2n9VSbw40/8cpvwQ../jetsynthesys_pvt_ltd__logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "jetsynthesys_pvt_ltd__logo.jpeg",
          "path": "/vault/OXY-0ZPV/uWD3XQY2XIGfjfFR-m2n9VSbw40/8cpvwQ../jetsynthesys_pvt_ltd__logo.jpeg",
          "size": 3967,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Visual Designer",
      "skill_companies_id": 589
    },
    {
      "sort_order": 46,
      "user_details": {
        "name": "Suchana Pati",
        "linkedin_url": "https://www.linkedin.com/in/suchana-pati-b997b3267/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/RS6yB5mV48qvigmEQzcMSXHhxo4/mz5tsA../1687863486132.jpg"
      },
      "company_details": {
        "id": 47,
        "created_at": 1661988815622,
        "name_alias": "alias name needed",
        "company_link": "https://www.genpact.com/careers",
        "company_name": "Genpact",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1719928740495.jpeg",
          "path": "/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "size": 5159,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Quality Auditor",
      "skill_companies_id": 47
    },
    {
      "sort_order": 47,
      "user_details": {
        "name": "Girish N",
        "linkedin_url": "https://www.linkedin.com/in/girish-n-a24396172/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/IKrTSiJTL4X8Q39IwkgJrUh-yjg/rOjgTw../1675353763961.jpg"
      },
      "company_details": {
        "id": 607,
        "created_at": 1725884842846,
        "name_alias": "Carelon Global Solutions",
        "company_link": "https://www.carelonglobal.in",
        "company_name": "Carelon Global Solutions",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/6jsUwfEiVIIpJgvY7mkMAc-gppM/HLXSHg../carelon_global_solutions_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "carelon_global_solutions_logo.jpeg",
          "path": "/vault/OXY-0ZPV/6jsUwfEiVIIpJgvY7mkMAc-gppM/HLXSHg../carelon_global_solutions_logo.jpeg",
          "size": 6924,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Quality Control Specialist",
      "skill_companies_id": 607
    },
    {
      "sort_order": 48,
      "user_details": {
        "name": "Vivekanand Raut",
        "linkedin_url": "https://www.linkedin.com/in/vivekanand-raut/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Vjpm_2Xus68CTzWbEiOwHxsMIvc/GKXWFw../1718255531465.jpg"
      },
      "company_details": {
        "id": 628,
        "created_at": 1726370738697,
        "name_alias": "Xoriant",
        "company_link": "https://www.xoriant.com/",
        "company_name": "Xoriant",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/CLCemNlwSByUminpD9iwlxmyt6I/FWMLkA../Screenshot%2B2024-09-15%2Bat%2B8.55.23%E2%80%AFAM.png",
          "meta": {
            "width": 174,
            "height": 134
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-15+at+8.55.23â€¯AM.png",
          "path": "/vault/OXY-0ZPV/CLCemNlwSByUminpD9iwlxmyt6I/FWMLkA../Screenshot%2B2024-09-15%2Bat%2B8.55.23%E2%80%AFAM.png",
          "size": 18690,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Business Analyst",
      "skill_companies_id": 628
    },
    {
      "sort_order": 49,
      "user_details": {
        "name": "Krishna Patel",
        "linkedin_url": "https://www.linkedin.com/in/krishna-patel-2a91611b0/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/qDXwwe6szV64ZhUSETmd5P73kso/YwblNg../1727899763588.jpg"
      },
      "company_details": {
        "id": 631,
        "created_at": 1726371143216,
        "name_alias": "StaffChase",
        "company_link": "https://staffchase.com/",
        "company_name": "StaffChase",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/29mPTdqwmKY8kqVMQXIHT5LmJjU/_EJOxw../Screenshot%2B2024-09-15%2Bat%2B9.02.08%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-15+at+9.02.08â€¯AM.png",
          "path": "/vault/OXY-0ZPV/29mPTdqwmKY8kqVMQXIHT5LmJjU/_EJOxw../Screenshot%2B2024-09-15%2Bat%2B9.02.08%E2%80%AFAM.png",
          "size": 29788,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Healthcare Recruitment Specialist / Sr Sourcing Specialist",
      "skill_companies_id": 631
    },
    {
      "sort_order": 50,
      "user_details": {
        "name": "Rishikesh Shrivastava",
        "linkedin_url": "https://www.linkedin.com/in/rishikesh-shrivastava-6b8a55187/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/lGx86fhqtdum5fWy6GPKBXuu4fU/vBBrSA../1731845347022.jpg"
      },
      "company_details": {
        "id": 608,
        "created_at": 1725885006353,
        "name_alias": "Keka",
        "company_link": "https://www.keka.com/",
        "company_name": "Keka",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/igW77TG9MMsZ_JMyc7DrFJNX0Zo/mx_QBw../keka_hr_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "keka_hr_logo.jpeg",
          "path": "/vault/OXY-0ZPV/igW77TG9MMsZ_JMyc7DrFJNX0Zo/mx_QBw../keka_hr_logo.jpeg",
          "size": 4450,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Account Executive - Americas (Charter Member)",
      "skill_companies_id": 608
    }
  ,
    {
      "sort_order": 51,
      "user_details": {
        "name": "Karan Mankar",
        "linkedin_url": "https://www.linkedin.com/in/karan-mankar-439139168/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ZZZhgDSfMXbu9Hg6VY3ngZiGK4I/5nm7eA../1673896107805.jpg"
      },
      "company_details": {
        "id": 592,
        "created_at": 1725880644408,
        "name_alias": "spotify nichname",
        "company_link": "https://www.ptw.com/",
        "company_name": "PTW",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/eTSXOxoDaJKx4mubzGO643Y3-sY/qvuW-Q../ptwintl_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "ptwintl_logo.jpeg",
          "path": "/vault/OXY-0ZPV/eTSXOxoDaJKx4mubzGO643Y3-sY/qvuW-Q../ptwintl_logo.jpeg",
          "size": 4552,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Test Engineer",
      "skill_companies_id": 592
    },
    {
      "sort_order": 52,
      "user_details": {
        "name": "Noorain Sayyed Hussaini",
        "linkedin_url": "https://www.linkedin.com/in/noorain-b-5929151aa/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ALFE61jI3RkhlCf9i2t6jK-Xpwk/a6AFrw../1728316610193.jpg"
      },
      "company_details": {
        "id": 619,
        "created_at": 1726312120430,
        "name_alias": "Kaseya",
        "company_link": "https://www.kaseya.com/",
        "company_name": "Kaseya",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ecWtv5bghl3ObSqS88ooRV6Sjfg/vo2e7w../Screenshot%2B2024-09-14%2Bat%2B4.38.25%E2%80%AFPM.png",
          "meta": {
            "width": 180,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-14+at+4.38.25â€¯PM.png",
          "path": "/vault/OXY-0ZPV/ecWtv5bghl3ObSqS88ooRV6Sjfg/vo2e7w../Screenshot%2B2024-09-14%2Bat%2B4.38.25%E2%80%AFPM.png",
          "size": 24004,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Project Coordinator ",
      "skill_companies_id": 619
    },
    {
      "sort_order": 53,
      "user_details": {
        "name": "Sudhir Achari",
        "linkedin_url": "https://www.linkedin.com/in/sudhirachari/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/wTNR3XRnobmZpUtihrseZvN1orw/2EzcWg../1724827402296.jpg"
      },
      "company_details": {
        "id": 688,
        "created_at": 1730777999468,
        "name_alias": "MediaMint",
        "company_link": "http://www.mediamint.com/",
        "company_name": "MediaMint",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/KjULK-SperKC7J-VIXK6DaC5BxQ/VjIVTg../25.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "25.jpeg",
          "path": "/vault/OXY-0ZPV/KjULK-SperKC7J-VIXK6DaC5BxQ/VjIVTg../25.jpeg",
          "size": 4500,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Associate Manager",
      "skill_companies_id": 688
    },
    {
      "sort_order": 54,
      "user_details": {
        "name": "Kamal Setia",
        "linkedin_url": "https://www.linkedin.com/in/kamal-setia/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/sIDdR2X9fWZRhgmrAN53whvst2U/VhA0RQ../1618299644530.jpg"
      },
      "company_details": {
        "id": 47,
        "created_at": 1661988815622,
        "name_alias": "alias name needed",
        "company_link": "https://www.genpact.com/careers",
        "company_name": "Genpact",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1719928740495.jpeg",
          "path": "/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "size": 5159,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Associate",
      "skill_companies_id": 47
    },
    {
      "sort_order": 55,
      "user_details": {
        "name": "Parag Ghag",
        "linkedin_url": "https://www.linkedin.com/in/parag-ghag-251252157/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/26PkbDbOW8UsaFQGVDSHLvp1lL0/UlTqUw../1710314253841.jpg"
      },
      "company_details": {
        "id": 605,
        "created_at": 1725883252698,
        "name_alias": "QX Global Group",
        "company_link": "https://qxglobalgroup.com/",
        "company_name": "QX Global Group",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/NCCsK0Zd0hART4dAONSFKRyLfGo/oH_siQ../qxglobalgroup_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "qxglobalgroup_logo.jpeg",
          "path": "/vault/OXY-0ZPV/NCCsK0Zd0hART4dAONSFKRyLfGo/oH_siQ../qxglobalgroup_logo.jpeg",
          "size": 7612,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Credit Controller",
      "skill_companies_id": 605
    },
    {
      "sort_order": 56,
      "user_details": {
        "name": "Nitu Choudhury",
        "linkedin_url": "https://www.linkedin.com/in/nitu-choudhury-7b048061/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/vW4OAj_540UBh6-tFtsvK_24s44/vLfzag../1719822100024.jpg"
      },
      "company_details": {
        "id": 672,
        "created_at": 1730776675292,
        "name_alias": "Gainwell Technologies",
        "company_link": "http://www.gainwelltechnologies.com/",
        "company_name": "Gainwell Technologies",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/n4P5NfyeVjjcI-XLkbrRm_Za5rM/AeAD-w../9.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "9.jpeg",
          "path": "/vault/OXY-0ZPV/n4P5NfyeVjjcI-XLkbrRm_Za5rM/AeAD-w../9.jpeg",
          "size": 2524,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Professional 2",
      "skill_companies_id": 672
    },
    {
      "sort_order": 57,
      "user_details": {
        "name": "Faiz Naqvi",
        "linkedin_url": "https://www.linkedin.com/in/faiz-naqvi-796789187/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/OuhY24ChWrhRJKWwJ2Nha1VAqNw/hXDEog../1725902085197.jpg"
      },
      "company_details": {
        "id": 676,
        "created_at": 1730776945801,
        "name_alias": "Allianz Partners",
        "company_link": "https://www.allianz-partners.com/",
        "company_name": "Allianz Partners",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/m9f-EVsLC3wZl0en9FVaJZnZRMM/M8VT_Q../13.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "13.jpeg",
          "path": "/vault/OXY-0ZPV/m9f-EVsLC3wZl0en9FVaJZnZRMM/M8VT_Q../13.jpeg",
          "size": 9883,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Quality Analyst",
      "skill_companies_id": 676
    },
    {
      "sort_order": 58,
      "user_details": {
        "name": "Chandan (Somesh) Mishra",
        "linkedin_url": "https://www.linkedin.com/in/chandan909/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/HYvt3D-USW4HVaUjSMweADEY6UY/MD1fEQ../1696087571985.jpg"
      },
      "company_details": {
        "id": 681,
        "created_at": 1730777387038,
        "name_alias": "Unstop",
        "company_link": "https://unstop.com/?utm_source=linkedin&utm_medium=social&ref=social",
        "company_name": "Unstop",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/qjoncQkLF9pCqyVSz96xQDeaLYs/i-By6g../18.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "18.jpeg",
          "path": "/vault/OXY-0ZPV/qjoncQkLF9pCqyVSz96xQDeaLYs/i-By6g../18.jpeg",
          "size": 5160,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Technical Content and Assessments Intern",
      "skill_companies_id": 681
    },
    {
      "sort_order": 59,
      "user_details": {
        "name": "Gayatri Mehta",
        "linkedin_url": "https://www.linkedin.com/in/gayatri-mehta-9734531b7/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/D9aSTltc7gEijV2uhublxNks_b8/WspnHg../1730147202311.jpg"
      },
      "company_details": {
        "id": 682,
        "created_at": 1730777461516,
        "name_alias": "WIZCRAFT ENTERTAINMENT AGENCY PRIVATE LIMITED",
        "company_link": "https://wizcraft.co/",
        "company_name": "WIZCRAFT ENTERTAINMENT AGENCY PRIVATE LIMITED",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/HG5nHfk4AEQvSPowJFGGiUGX8gQ/CG6mxg../19.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "19.jpeg",
          "path": "/vault/OXY-0ZPV/HG5nHfk4AEQvSPowJFGGiUGX8gQ/CG6mxg../19.jpeg",
          "size": 6097,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Client Servicing",
      "skill_companies_id": 682
    },
    {
      "sort_order": 60,
      "user_details": {
        "name": "Prabhu Mallick",
        "linkedin_url": "https://www.linkedin.com/in/prabhumallick/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/gh-4dFZfemJMLf71lyYv8EI91-Q/gn3pLQ../1721655923371.jpg"
      },
      "company_details": {
        "id": 626,
        "created_at": 1726312957672,
        "name_alias": "Medline",
        "company_link": "https://www.medline.com/",
        "company_name": "Medline",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/FRoDW4_sBcJiKEAfwDsrACAOO9I/2jWRJQ../Screenshot%2B2024-09-14%2Bat%2B4.52.21%E2%80%AFPM.png",
          "meta": {
            "width": 168,
            "height": 166
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-14+at+4.52.21â€¯PM.png",
          "path": "/vault/OXY-0ZPV/FRoDW4_sBcJiKEAfwDsrACAOO9I/2jWRJQ../Screenshot%2B2024-09-14%2Bat%2B4.52.21%E2%80%AFPM.png",
          "size": 20553,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Manager - IT Infrastructure & Cloud Services",
      "skill_companies_id": 626
    }
  ,
    {
      "sort_order": 61,
      "user_details": {
        "name": "Venkatesh Kumar",
        "linkedin_url": "https://www.linkedin.com/in/venkatesh-kumar-77898b192/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/xRDtaKlOFUIUwl8hWsesWbYlsdU/-mYfTg../1718231214886.jpg"
      },
      "company_details": {
        "id": 599,
        "created_at": 1725882499778,
        "name_alias": "CITI",
        "company_link": "http://www.citigroup.com/",
        "company_name": "CITI",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/O8v5c2ZDg1OBdtxeX4Gm3OhEKZQ/tmmPzQ../citi_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "citi_logo.jpeg",
          "path": "/vault/OXY-0ZPV/O8v5c2ZDg1OBdtxeX4Gm3OhEKZQ/tmmPzQ../citi_logo.jpeg",
          "size": 4531,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Assistant Vice President",
      "skill_companies_id": 599
    },
    {
      "sort_order": 62,
      "user_details": {
        "name": "Neelam Kumar",
        "linkedin_url": "https://www.linkedin.com/in/neelam-kumar-08aa7918/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/m-CfOSmUlWkcXQVDC4v4BvCIwas/2vtyMA../1630177995945.jpg"
      },
      "company_details": {
        "id": 613,
        "created_at": 1725888090152,
        "name_alias": "WAISL Limited",
        "company_link": "https://www.waisl.in/",
        "company_name": "WAISL Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/QLX9gY8EP6WJYO4iXBHY2uPJO4U/oaIwIw../waisl_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "waisl_logo.jpeg",
          "path": "/vault/OXY-0ZPV/QLX9gY8EP6WJYO4iXBHY2uPJO4U/oaIwIw../waisl_logo.jpeg",
          "size": 3900,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "DigiYatra/IT Operation Lead",
      "skill_companies_id": 613
    },
    {
      "sort_order": 63,
      "user_details": {
        "name": "Jackson Nadar",
        "linkedin_url": "https://www.linkedin.com/in/jackson-nadar-01a594b8/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/azFKPYI-oPVL41nnIBtOSnoGcyw/u6KqiQ../1651136870458.jpg"
      },
      "company_details": {
        "id": 604,
        "created_at": 1725883175107,
        "name_alias": "Dusters Total Solutions Services Private Limited",
        "company_link": "http://www.dtss.in",
        "company_name": "Dusters Total Solutions Services Private Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/IqoHziobqsGONL5h3KQUAoeIBLA/Q9rZRg../dusters_total_solution_services_private_limited_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "dusters_total_solution_services_private_limited_logo.jpeg",
          "path": "/vault/OXY-0ZPV/IqoHziobqsGONL5h3KQUAoeIBLA/Q9rZRg../dusters_total_solution_services_private_limited_logo.jpeg",
          "size": 6907,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Assistant General Manager",
      "skill_companies_id": 604
    },
    {
      "sort_order": 64,
      "user_details": {
        "name": "Chakradharudu SABBISETTI",
        "linkedin_url": "https://www.linkedin.com/in/chakradharudu-sabbisetti-b6ab693a/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/JhHPVeQdg87qPrsl2wdwC4ewHFQ/KduEnQ../1716080319236.jpg"
      },
      "company_details": {
        "id": 614,
        "created_at": 1725888317154,
        "name_alias": "Alvotech",
        "company_link": "http://www.alvotech.com/",
        "company_name": "Alvotech",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/1hnywKneLjp9GmPuD_ATgsETiN8/FXvk4A../alvotechpr_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "alvotechpr_logo.jpeg",
          "path": "/vault/OXY-0ZPV/1hnywKneLjp9GmPuD_ATgsETiN8/FXvk4A../alvotechpr_logo.jpeg",
          "size": 4625,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Operations Manager-DSP",
      "skill_companies_id": 614
    },
    {
      "sort_order": 65,
      "user_details": {
        "name": "Chandan Jain",
        "linkedin_url": "https://www.linkedin.com/in/chandan-jain-572383118/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/xPjOkiDICuaOoT7MfoZhtxfuN6Y/Q5RY2g../1661349274634.jpg"
      },
      "company_details": {
        "id": 639,
        "created_at": 1726459656917,
        "name_alias": "Ind-Swift Limited",
        "company_link": "https://www.indswiftltd.com/",
        "company_name": "Ind-Swift Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/mwwg5LbWAta7RK7i8__sqfz8jzg/tqnOEA../Screenshot%2B2024-09-16%2Bat%2B9.37.22%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.37.22â€¯AM.png",
          "path": "/vault/OXY-0ZPV/mwwg5LbWAta7RK7i8__sqfz8jzg/tqnOEA../Screenshot%2B2024-09-16%2Bat%2B9.37.22%E2%80%AFAM.png",
          "size": 22150,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nOfficer",
      "skill_companies_id": 639
    },
    {
      "sort_order": 66,
      "user_details": {
        "name": "Onkar Arora",
        "linkedin_url": "https://www.linkedin.com/in/onkar-arora-539336108/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/CSuq69FrPZVEzvrz9kwxNMZQyKo/UdE-WQ../1657931233189.jpg"
      },
      "company_details": {
        "id": 47,
        "created_at": 1661988815622,
        "name_alias": "alias name needed",
        "company_link": "https://www.genpact.com/careers",
        "company_name": "Genpact",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1719928740495.jpeg",
          "path": "/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "size": 5159,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nAssistant Manager - Operations",
      "skill_companies_id": 47
    },
    {
      "sort_order": 67,
      "user_details": {
        "name": "Salman Abdur Reheman",
        "linkedin_url": "https://www.linkedin.com/in/salmanrehman30/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/HMG9d85lgqskQbKdENo99PHoGE4/Fgu7-A../1728881590661.jpg"
      },
      "company_details": {
        "id": 640,
        "created_at": 1726459779564,
        "name_alias": "FULL",
        "company_link": "https://full.io/",
        "company_name": "FULL",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/R-XYXfylmEI2dnlNRz7oYRYT_bM/epFdlw../Screenshot%2B2024-09-16%2Bat%2B9.39.25%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.39.25â€¯AM.png",
          "path": "/vault/OXY-0ZPV/R-XYXfylmEI2dnlNRz7oYRYT_bM/epFdlw../Screenshot%2B2024-09-16%2Bat%2B9.39.25%E2%80%AFAM.png",
          "size": 5288,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Business Development Executive",
      "skill_companies_id": 640
    },
    {
      "sort_order": 68,
      "user_details": {
        "name": "Poorvi Malviya",
        "linkedin_url": "https://www.linkedin.com/in/poorvi-malviya-3912a9198/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/LkVIwCX5SajqS8uEzR8bhUCMjfo/joUx9w../1729680101444.jpg"
      },
      "company_details": {
        "id": 663,
        "created_at": 1730704641076,
        "name_alias": "GirlScript Summer of Code",
        "company_link": "https://gssoc.girlscript.tech/",
        "company_name": "GirlScript Summer of Code",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/tz87Ce4CQdEOA6s0YdJJ63-qvrc/cwT9Kg../girlscriptsoc_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "girlscriptsoc_logo.jpeg",
          "path": "/vault/OXY-0ZPV/tz87Ce4CQdEOA6s0YdJJ63-qvrc/cwT9Kg../girlscriptsoc_logo.jpeg",
          "size": 10521,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Contributor",
      "skill_companies_id": 663
    },
    {
      "sort_order": 69,
      "user_details": {
        "name": "Selvakumar Muthukrishnan",
        "linkedin_url": "https://www.linkedin.com/in/selvakumar-muthukrishnan-124b6515/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/nA9ragMnnA-OrCVd_OL_ufYQImk/pRUcpA../1715077089947.jpg"
      },
      "company_details": {
        "id": 593,
        "created_at": 1725880779895,
        "name_alias": "Meraki Carriers Private Limited",
        "company_link": "https://merakicarriers.in/",
        "company_name": "Meraki Carriers Private Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/nX2JLCKixPJ1LADfYNiGB0PiSKk/n5Lxcw../1623957208377.jpeg",
          "meta": {
            "width": 400,
            "height": 400
          },
          "mime": "image/jpeg",
          "name": "1623957208377.jpeg",
          "path": "/vault/OXY-0ZPV/nX2JLCKixPJ1LADfYNiGB0PiSKk/n5Lxcw../1623957208377.jpeg",
          "size": 8302,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Director",
      "skill_companies_id": 593
    },
    {
      "sort_order": 70,
      "user_details": {
        "name": "VK Rajendra",
        "linkedin_url": "https://www.linkedin.com/in/vk-rajendran-52935618/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/EviTvkMaAyYD84NxczL0BLUNf5c/kh9m0Q../1632495932841.jpg"
      },
      "company_details": {
        "id": 673,
        "created_at": 1730776746506,
        "name_alias": "Karomi",
        "company_link": "http://www.karomi.com/",
        "company_name": "Karomi Technology Private Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/TMwzujb90ow3jUK13xQRiLcS7ro/0T-9FQ../10.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "10.jpeg",
          "path": "/vault/OXY-0ZPV/TMwzujb90ow3jUK13xQRiLcS7ro/0T-9FQ../10.jpeg",
          "size": 5221,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Manager ( Delivery & Operation)",
      "skill_companies_id": 673
    }
  ,
    {
      "sort_order": 71,
      "user_details": {
        "name": "Ravi Kant TIwary",
        "linkedin_url": "https://www.linkedin.com/in/ravi-kant-tiwary-43164422/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/S3aSZ-uEU8iv2YUl9sh98PjG0wI/YlyxoQ../1623419780858.jpg"
      },
      "company_details": {
        "id": 644,
        "created_at": 1726460265254,
        "name_alias": "Prudent Corporate Advisory Services Ltd",
        "company_link": "https://www.prudentcorporate.com/home",
        "company_name": "Prudent Corporate Advisory Services Ltd",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/-ouILFMc6dhaTgsnjCWuS-ua4ek/B-HZfg../Screenshot%2B2024-09-16%2Bat%2B9.46.47%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.46.47â€¯AM.png",
          "path": "/vault/OXY-0ZPV/-ouILFMc6dhaTgsnjCWuS-ua4ek/B-HZfg../Screenshot%2B2024-09-16%2Bat%2B9.46.47%E2%80%AFAM.png",
          "size": 37606,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Portfolio Manager",
      "skill_companies_id": 644
    },
    {
      "sort_order": 72,
      "user_details": {
        "name": "Nikhil Mehta",
        "linkedin_url": "https://www.linkedin.com/in/nikhil-mehta-6011453b/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/2Ty-NM_Mm4LdzSzWj3UCHeYzy60/-TIWXQ../1726870324844.jpg"
      },
      "company_details": {
        "id": 675,
        "created_at": 1730776887110,
        "name_alias": "The Monarch Enterprises",
        "company_link": "https://www.themonarchenterprises.com/",
        "company_name": "The Monarch Enterprises",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Nx9egcfqdIzwiw0bJut4yE7CUdQ/iw7TBQ../12.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "12.jpeg",
          "path": "/vault/OXY-0ZPV/Nx9egcfqdIzwiw0bJut4yE7CUdQ/iw7TBQ../12.jpeg",
          "size": 6835,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "General Manager - Digital Marketing, Strategy and Growth",
      "skill_companies_id": 675
    },
    {
      "sort_order": 73,
      "user_details": {
        "name": "Mudit Agarwal",
        "linkedin_url": "https://www.linkedin.com/in/mudit-agarwal-926b4825/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/R8xdso-iTP39hi1gnkXdadESE3s/-jLfcQ../1697718531947.jpg"
      },
      "company_details": {
        "id": 627,
        "created_at": 1726370645826,
        "name_alias": "PALI HILLS BREWERIES PRIVATE LIMITED",
        "company_link": "https://www.linkedin.com/company/pali-hills-breweries-private-limited/?originalSubdomain=in",
        "company_name": "PALI HILLS BREWERIES PRIVATE LIMITED",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/DR_T9vrQ2eRVFRaBTpBWAzTeFxQ/SbmyVw../Screenshot%2B2024-09-15%2Bat%2B8.53.28%E2%80%AFAM.png",
          "meta": {
            "width": 174,
            "height": 134
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-15+at+8.53.28â€¯AM.png",
          "path": "/vault/OXY-0ZPV/DR_T9vrQ2eRVFRaBTpBWAzTeFxQ/SbmyVw../Screenshot%2B2024-09-15%2Bat%2B8.53.28%E2%80%AFAM.png",
          "size": 45666,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Operations Manager",
      "skill_companies_id": 627
    },
    {
      "sort_order": 74,
      "user_details": {
        "name": "Ishita Bhatnagar",
        "linkedin_url": "https://www.linkedin.com/in/ishita-bhatnagar-a3897617/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/24dp_9DV4obhX8ck55Z7EWOMmJ0/fgJLeQ../1725486996449.jpg"
      },
      "company_details": {
        "id": 621,
        "created_at": 1726312337218,
        "name_alias": "Roongta Cinemas",
        "company_link": "https://rcinemas.in/",
        "company_name": "Roongta Cinemas",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/HZawqx5XzSqV0iuonmZfko81dqw/PNrqlA../Screenshot%2B2024-09-14%2Bat%2B4.42.01%E2%80%AFPM.png",
          "meta": {
            "width": 180,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-14+at+4.42.01â€¯PM.png",
          "path": "/vault/OXY-0ZPV/HZawqx5XzSqV0iuonmZfko81dqw/PNrqlA../Screenshot%2B2024-09-14%2Bat%2B4.42.01%E2%80%AFPM.png",
          "size": 36568,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "VP - Sales & Marketing",
      "skill_companies_id": 621
    },
    {
      "sort_order": 75,
      "user_details": {
        "name": "ambrish chandra dixit",
        "linkedin_url": "https://www.linkedin.com/in/ambrish-chandra-dixit-33459230/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/uLgS29IgH7Xr7_HynoALisjVQ6g/IM0EDg../1598518082775.jpg"
      },
      "company_details": {
        "id": 677,
        "created_at": 1730777004546,
        "name_alias": "AQM Technologies",
        "company_link": "http://www.aqmtechnologies.com/",
        "company_name": "AQM Technologies",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/hZ5U1qwg_znhNK6siJfgcCuz-pc/tpgnLA../14.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "14.jpeg",
          "path": "/vault/OXY-0ZPV/hZ5U1qwg_znhNK6siJfgcCuz-pc/tpgnLA../14.jpeg",
          "size": 2980,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Customer Support Team Lead",
      "skill_companies_id": 677
    },
    {
      "sort_order": 76,
      "user_details": {
        "name": "sachin goyal",
        "linkedin_url": "https://www.linkedin.com/in/sachin-goyal-91411658/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/WylVUMd159h_i9EFvTl5ek_KF84/5LGY7Q../1728615026338.jpg"
      },
      "company_details": {
        "id": 680,
        "created_at": 1730777326652,
        "name_alias": "INSTITUTE OF MANAGEMENT AND RESEARCH, GHAZIABAD",
        "company_link": "https://www.imrghaziabad.ac.in/",
        "company_name": "INSTITUTE OF MANAGEMENT AND RESEARCH, GHAZIABAD",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/5UA3BjGJEEYFCfrN5Fly6Zz9JGY/xyeeqw../17.jpeg",
          "meta": {
            "width": 225,
            "height": 225
          },
          "mime": "image/jpeg",
          "name": "17.jpeg",
          "path": "/vault/OXY-0ZPV/5UA3BjGJEEYFCfrN5Fly6Zz9JGY/xyeeqw../17.jpeg",
          "size": 12556,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Assistant Professor",
      "skill_companies_id": 680
    },
    {
      "sort_order": 77,
      "user_details": {
        "name": "Aatulya Tanmaya Raman",
        "linkedin_url": "https://www.linkedin.com/in/aatulyatanmayaraman/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/qGO2KnAlP8TXz7i7uXfbvvrnOXo/Ek6Vow../1731767529967.jpg"
      },
      "company_details": {
        "id": 603,
        "created_at": 1725883063932,
        "name_alias": "Unified Mentor Private Limited",
        "company_link": "https://unifiedmentor.com/",
        "company_name": "Unified Mentor Private Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/fdP4S9sE5KwV2dHVAbmsbPzyfGs/k29BNg../1694669130240.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1694669130240.jpeg",
          "path": "/vault/OXY-0ZPV/fdP4S9sE5KwV2dHVAbmsbPzyfGs/k29BNg../1694669130240.jpeg",
          "size": 3106,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Data Scientist",
      "skill_companies_id": 603
    },
    {
      "sort_order": 78,
      "user_details": {
        "name": "Pankaj Kannaujiya",
        "linkedin_url": "https://www.linkedin.com/in/pankaj-kannaujiya-7b5554179/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/qxJ1lkSgdCu1Sl3IH-atBHCPvUs/3LkoQw../1718422555065.jpg"
      },
      "company_details": {
        "id": 645,
        "created_at": 1726460332420,
        "name_alias": "XL KPO Service",
        "company_link": "https://partagun.ru/?u=zt2kd0d&o=t7km547&m=1",
        "company_name": "XL KPO Service",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/XbRNFXsfqK-ntaexWolQMouiKx4/fRn2Og../Screenshot%2B2024-09-16%2Bat%2B9.48.23%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.48.23â€¯AM.png",
          "path": "/vault/OXY-0ZPV/XbRNFXsfqK-ntaexWolQMouiKx4/fRn2Og../Screenshot%2B2024-09-16%2Bat%2B9.48.23%E2%80%AFAM.png",
          "size": 28153,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nAccount Operations Manager",
      "skill_companies_id": 645
    },
    {
      "sort_order": 79,
      "user_details": {
        "name": "Kiran Kumar Rohidas",
        "linkedin_url": "https://www.linkedin.com/in/kiran-kumar-rohidas-63322821/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/kuSROIrSuv0GNW3WRX1TGN4Y80Q/BSFq9Q../1731224553008.jpg"
      },
      "company_details": {
        "id": 660,
        "created_at": 1726916553464,
        "name_alias": "Sandpiper",
        "company_link": "https://www.sandpipervisas.com/",
        "company_name": "Sandpiper",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/TjmVYonOnG9Rc5F-dEkjoKkH1pw/VvCs2A../1720014926077.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1720014926077.jpeg",
          "path": "/vault/OXY-0ZPV/TjmVYonOnG9Rc5F-dEkjoKkH1pw/VvCs2A../1720014926077.jpeg",
          "size": 5728,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Immigration Case Manager",
      "skill_companies_id": 660
    },
    {
      "sort_order": 80,
      "user_details": {
        "name": "Ugender Rao Dechoupantula",
        "linkedin_url": "https://www.linkedin.com/in/ugenderraodechoupantula/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/2-i6dxmzckJYYo43GqcDi7m_60o/n1UT-w../1721216828334.jpg"
      },
      "company_details": {
        "id": 617,
        "created_at": 1726027808701,
        "name_alias": "Techsol Life Sciences",
        "company_link": "https://www.techsollifesciences.com/",
        "company_name": "Techsol Life Sciences",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/pia37_xk2r_QaFixP3q5a5vLPTY/MqaBpg../techsol_life_sciences_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "techsol_life_sciences_logo.jpeg",
          "path": "/vault/OXY-0ZPV/pia37_xk2r_QaFixP3q5a5vLPTY/MqaBpg../techsol_life_sciences_logo.jpeg",
          "size": 4727,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Service Delivery Manager-Infra & Managed Services",
      "skill_companies_id": 617
    }
    ,
    {
      "sort_order": 81,
      "user_details": {
        "name": "Jagpreet Singh",
        "linkedin_url": "https://www.linkedin.com/in/jagpreet-singh-77562955/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/84bnZqtPFTC_GpBVJU3d_JJWNQ8/EBFYkw../1660035816219.jpg"
      },
      "company_details": {
        "id": 683,
        "created_at": 1730777534307,
        "name_alias": "Angara E-Commerce Pvt. Ltd.",
        "company_link": "https://www.angara.com/b/about-us?srsltid=AfmBOoqUYt3ZsdKkO7wyiYJMI25jkdi6rwJESS8O8xPTle1-s17z0axl",
        "company_name": "Angara E-Commerce Pvt. Ltd.",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/8mMc1pJ0WcFGyymPw7_tezygf38/XkDPew../20.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "20.jpeg",
          "path": "/vault/OXY-0ZPV/8mMc1pJ0WcFGyymPw7_tezygf38/XkDPew../20.jpeg",
          "size": 2938,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Administration Manager",
      "skill_companies_id": 683
    },
    {
      "sort_order": 82,
      "user_details": {
        "name": "Jigar Swami",
        "linkedin_url": "https://www.linkedin.com/in/jigar-swami-b202a9119/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Pg9UW59FZEyqjpqie5kMLsOtbGw/oX1XDQ../1517598735053.jpg"
      },
      "company_details": {
        "id": 651,
        "created_at": 1726460920478,
        "name_alias": "Cohance Lifesciences",
        "company_link": "https://www.cohance.com/",
        "company_name": "Cohance Lifesciences",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/jZgHfN1ILt_XCGW6keNJMfT2MtM/8PVynQ../Screenshot%2B2024-09-16%2Bat%2B9.58.25%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.58.25â€¯AM.png",
          "path": "/vault/OXY-0ZPV/jZgHfN1ILt_XCGW6keNJMfT2MtM/8PVynQ../Screenshot%2B2024-09-16%2Bat%2B9.58.25%E2%80%AFAM.png",
          "size": 22709,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Manager",
      "skill_companies_id": 651
    },
    {
      "sort_order": 83,
      "user_details": {
        "name": "mayank soni",
        "linkedin_url": "https://www.linkedin.com/in/mayank-soni-21480447/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Ad8UgUenngvwgWuM_sTkv7P6st4/XhR85Q../1634208843057.jpg"
      },
      "company_details": {
        "id": 684,
        "created_at": 1730777607406,
        "name_alias": "TP Southern Odisha Distribution Limited",
        "company_link": "http://www.tpsouthernodisha.com/",
        "company_name": "TP Southern Odisha Distribution Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/65u9z43CCnNOA024iYkPtC6Col8/tS4Qig../21.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "21.jpeg",
          "path": "/vault/OXY-0ZPV/65u9z43CCnNOA024iYkPtC6Col8/tS4Qig../21.jpeg",
          "size": 5715,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Team Lead- Network, Engineering & Planning",
      "skill_companies_id": 684
    },
    {
      "sort_order": 84,
      "user_details": {
        "name": "KURRA SIVA RAMA KRISHNA",
        "linkedin_url": "https://www.linkedin.com/in/siva-rama-krishna-kurra-01835840/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/p541XzFbCybD7bYSqDJ5ADEvMxE/WDk_5Q../1679189485988.jpg"
      },
      "company_details": {
        "id": 685,
        "created_at": 1730777677971,
        "name_alias": "Tyger Capital (formerly Adani Capital)",
        "company_link": "https://www.tyger.in/",
        "company_name": "Tyger Capital (formerly Adani Capital)",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/JqF3Shy7CaxyCxvFkhvfmhhPOEc/63JSGw../22.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "22.jpeg",
          "path": "/vault/OXY-0ZPV/JqF3Shy7CaxyCxvFkhvfmhhPOEc/63JSGw../22.jpeg",
          "size": 3312,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Assistant Vice President - Risk Control Unit",
      "skill_companies_id": 685
    },
    {
      "sort_order": 85,
      "user_details": {
        "name": "Gurjeet Arora",
        "linkedin_url": "https://www.linkedin.com/in/gurjeet-arora-1a69a789/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/_apwD6Ky86qKsgKW9cDvekRduS8/ebIl1Q../1732019669928.jpg"
      },
      "company_details": {
        "id": 650,
        "created_at": 1726460841909,
        "name_alias": "Hamamatsu Photonics UK Limited",
        "company_link": "https://www.hamamatsu.com/jp/en.html",
        "company_name": "Hamamatsu Photonics UK Limited",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/TBYPKNXDCueZXSbs3OoPpdAC38Q/OB71ew../Screenshot%2B2024-09-16%2Bat%2B9.56.51%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.56.51â€¯AM.png",
          "path": "/vault/OXY-0ZPV/TBYPKNXDCueZXSbs3OoPpdAC38Q/OB71ew../Screenshot%2B2024-09-16%2Bat%2B9.56.51%E2%80%AFAM.png",
          "size": 12211,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Sr. Technology Specialist",
      "skill_companies_id": 650
    },
    {
      "sort_order": 87,
      "user_details": {
        "name": "Jayanth B G",
        "linkedin_url": "https://www.linkedin.com/in/jayanth-b-g-b1691031/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/_ZSX4F3zzQ5WHNrXHV4rUXc52AY/rWfMSw../1715915661264.jpg"
      },
      "company_details": {
        "id": 636,
        "created_at": 1726459244816,
        "name_alias": "Dozee",
        "company_link": "https://www.dozeehealth.ai/",
        "company_name": "Dozee",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/juMgmlXk1GYV7h3t188-db2Djl8/QWZL1A../Screenshot%2B2024-09-16%2Bat%2B9.30.19%E2%80%AFAM.png",
          "meta": {
            "width": 182,
            "height": 186
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.30.19â€¯AM.png",
          "path": "/vault/OXY-0ZPV/juMgmlXk1GYV7h3t188-db2Djl8/QWZL1A../Screenshot%2B2024-09-16%2Bat%2B9.30.19%E2%80%AFAM.png",
          "size": 16627,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nRegional Manager - Customer Success",
      "skill_companies_id": 636
    },
    {
      "sort_order": 88,
      "user_details": {
        "name": "Mayur Deshmukh",
        "linkedin_url": "https://www.linkedin.com/in/mayur-deshmukh-26b139b0/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/_moXfMFNInMvh1eTrNCxcPdvFrE/6KZmDQ../1574310474518.jpg"
      },
      "company_details": {
        "id": 615,
        "created_at": 1726027416292,
        "name_alias": "Equifax",
        "company_link": "https://www.equifax.com/",
        "company_name": "Equifax",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/7g5ouocyG0_ScXQS6GTPS74EZlY/7p2tiA../equifax_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "equifax_logo.jpeg",
          "path": "/vault/OXY-0ZPV/7g5ouocyG0_ScXQS6GTPS74EZlY/7p2tiA../equifax_logo.jpeg",
          "size": 7187,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Technology Lead - Software - Career",
      "skill_companies_id": 615
    },
    {
      "sort_order": 89,
      "user_details": {
        "name": "Rakesh Kumar Gupta",
        "linkedin_url": "https://www.linkedin.com/in/rakesh-kumar-gupta-b066161b/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/WAKFhweOB1mTkks0yszWT2oASFg/xqxlQQ../1713889204542.jpg"
      },
      "company_details": {
        "id": 656,
        "created_at": 1726462024924,
        "name_alias": "Vacmet India Ltd",
        "company_link": "https://www.vpipl.co.in/",
        "company_name": "Vacmet India Ltd",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/X6WFgsok_h1BNnYemS714-5cWw4/QZNdMA../Screenshot%2B2024-09-16%2Bat%2B10.16.35%E2%80%AFAM.png",
          "meta": {
            "width": 192,
            "height": 168
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+10.16.35â€¯AM.png",
          "path": "/vault/OXY-0ZPV/X6WFgsok_h1BNnYemS714-5cWw4/QZNdMA../Screenshot%2B2024-09-16%2Bat%2B10.16.35%E2%80%AFAM.png",
          "size": 18003,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Executive Assistant to Director",
      "skill_companies_id": 656
    },
    {
      "sort_order": 90,
      "user_details": {
        "name": "Rahul Mathevan",
        "linkedin_url": "https://www.linkedin.com/in/rahul-mathevan-62a7b0b7/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/N8IbtySUjniSbNBkhWJ8WRQZRZk/rFZjvg../1611814163892.jpg"
      },
      "company_details": {
        "id": 606,
        "created_at": 1725883356671,
        "name_alias": "Moody's Ratings",
        "company_link": "http://www.moodys.com",
        "company_name": "Moody's Ratings",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/KJa1VjGC8YfkWbcAFYfmmW9MtEU/e92aAA../moodys_ratings_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "moodys_ratings_logo.jpeg",
          "path": "/vault/OXY-0ZPV/KJa1VjGC8YfkWbcAFYfmmW9MtEU/e92aAA../moodys_ratings_logo.jpeg",
          "size": 3758,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Production Associate ",
      "skill_companies_id": 606
    },
    {
      "sort_order": 92,
      "user_details": {
        "name": "AYSHWARYA MOHAN",
        "linkedin_url": "https://www.linkedin.com/in/ayshwarya-mohan-8b780773/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/CfrKEbC8pMrpaKnRzjGL4OVpIXM/zIrDDA../1607409775559.jpg"
      },
      "company_details": {
        "id": 591,
        "created_at": 1725880431531,
        "name_alias": "spotify nichname",
        "company_link": "http://www.cctspl.com/",
        "company_name": "CCTS Global",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/RBXlcragP6LJrbeTfah4uVpP7s8/E_XLpg../cctsglobal_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "cctsglobal_logo.jpeg",
          "path": "/vault/OXY-0ZPV/RBXlcragP6LJrbeTfah4uVpP7s8/E_XLpg../cctsglobal_logo.jpeg",
          "size": 6589,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Project Manager",
      "skill_companies_id": 591
    }
  ,
    {
      "sort_order": 93,
      "user_details": {
        "name": "Hari Prasad Vommi",
        "linkedin_url": "https://www.linkedin.com/in/hari-vommi-701b26145/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/KL5LDhOPMMSoUtoI5aOQYnk3y0w/AHGbAA../1593362048806.jpg"
      },
      "company_details": {
        "id": 686,
        "created_at": 1730777784067,
        "name_alias": "Mobily Infotech India Pvt Ltd",
        "company_link": "http://www.mobilyinfotech.com/",
        "company_name": "Mobily Infotech India Pvt Ltd",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ATyR1uzTYsBBCM6ViH4gJNSgr8c/hNSy7A../23.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "23.jpeg",
          "path": "/vault/OXY-0ZPV/ATyR1uzTYsBBCM6ViH4gJNSgr8c/hNSy7A../23.jpeg",
          "size": 8075,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Technology Lead",
      "skill_companies_id": 686
    },
    {
      "sort_order": 94,
      "user_details": {
        "name": "Karthickeyan V",
        "linkedin_url": "https://www.linkedin.com/in/karthickeyan-v-851210311/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/iIKjYFOVF1FSZbBSXJPT8fg8ONM/TLf7Fg../1725197475553.jpg"
      },
      "company_details": {
        "id": 602,
        "created_at": 1725882849532,
        "name_alias": "iMarque Solutions Pvt. Ltd",
        "company_link": "https://www.imarque.com",
        "company_name": "iMarque Solutions Pvt. Ltd",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Cp8RB8XDHlaucHrQQXnKicC88KA/1d0aIA../imarque_solutions_pvt_ltd_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "imarque_solutions_pvt_ltd_logo.jpeg",
          "path": "/vault/OXY-0ZPV/Cp8RB8XDHlaucHrQQXnKicC88KA/1d0aIA../imarque_solutions_pvt_ltd_logo.jpeg",
          "size": 6412,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Assistant Manager operations ",
      "skill_companies_id": 602
    },
    {
      "sort_order": 95,
      "user_details": {
        "name": "Deeppak Sharrma",
        "linkedin_url": "https://www.linkedin.com/in/deeppak-sharrma/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/E9y0i-gvDnNPZCRLvAqD-rhjU8c/lxbYDQ../1715487330166.jpg"
      },
      "company_details": {
        "id": 661,
        "created_at": 1726916676521,
        "name_alias": "Emarald",
        "company_link": "https://www.emarald.in/",
        "company_name": "Emarald",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/7Bid8YA5OdW3ORFwRnrOV5a3Bjw/v7k3iQ../1630596918397.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1630596918397.jpeg",
          "path": "/vault/OXY-0ZPV/7Bid8YA5OdW3ORFwRnrOV5a3Bjw/v7k3iQ../1630596918397.jpeg",
          "size": 10627,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Marketing Manager",
      "skill_companies_id": 661
    },
    {
      "sort_order": 96,
      "user_details": {
        "name": "Rinku Majumdar",
        "linkedin_url": "https://www.linkedin.com/in/rinku-majumdar/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/oiF-v4CmultGCod9575KLU3Oyok/SlLCIQ../1725012091209.jpg"
      },
      "company_details": {
        "id": 622,
        "created_at": 1726312420168,
        "name_alias": "Samaaro",
        "company_link": "https://samaaro.com/",
        "company_name": "Samaaro",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/s45j6jPHUlYEzBdxV6N913d8XfI/hCkLmw../Screenshot%2B2024-09-14%2Bat%2B4.43.26%E2%80%AFPM.png",
          "meta": {
            "width": 180,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-14+at+4.43.26â€¯PM.png",
          "path": "/vault/OXY-0ZPV/s45j6jPHUlYEzBdxV6N913d8XfI/hCkLmw../Screenshot%2B2024-09-14%2Bat%2B4.43.26%E2%80%AFPM.png",
          "size": 22075,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Customer Success Manager",
      "skill_companies_id": 622
    },
    {
      "sort_order": 97,
      "user_details": {
        "name": "Wayne Soares",
        "linkedin_url": "https://www.linkedin.com/in/wayne-soares-1056a013a/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/cY2MhQRhzhcHKig29FnlaAU-Dkc/sA7elg../1720204666136.jpg"
      },
      "company_details": {
        "id": 654,
        "created_at": 1726461608685,
        "name_alias": "Zynga",
        "company_link": "https://www.zynga.com/",
        "company_name": "Zynga",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/C8U1uNzbr4J0M-36YCBLOTF-wN8/DCbeDQ../Screenshot%2B2024-09-16%2Bat%2B10.09.49%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+10.09.49â€¯AM.png",
          "path": "/vault/OXY-0ZPV/C8U1uNzbr4J0M-36YCBLOTF-wN8/DCbeDQ../Screenshot%2B2024-09-16%2Bat%2B10.09.49%E2%80%AFAM.png",
          "size": 27339,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Producer at Merge Magic",
      "skill_companies_id": 654
    },
    {
      "sort_order": 98,
      "user_details": {
        "name": "Nupur Sambarwal",
        "linkedin_url": "https://www.linkedin.com/in/nupur-sambarwal-94321a17a/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/lCc5pjYxyeJ15shO_oW0XQ5IE1E/E2Xplw../1707917784213.jpg"
      },
      "company_details": {
        "id": 637,
        "created_at": 1726459393674,
        "name_alias": "GEDU Global Education",
        "company_link": "https://gedu.global/",
        "company_name": "GEDU Global Education",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/a4Tiyw8ucfq9KPUMyrSdztIwUEk/AyUOgg../Screenshot%2B2024-09-16%2Bat%2B9.32.59%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.32.59â€¯AM.png",
          "path": "/vault/OXY-0ZPV/a4Tiyw8ucfq9KPUMyrSdztIwUEk/AyUOgg../Screenshot%2B2024-09-16%2Bat%2B9.32.59%E2%80%AFAM.png",
          "size": 30519,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Visa Officer",
      "skill_companies_id": 637
    },
    {
      "sort_order": 99,
      "user_details": {
        "name": "Sravan Kumar",
        "linkedin_url": "https://www.linkedin.com/in/sravan-kumar-19aaa218b/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/cxaZxv_SW-tNmk8jgPtII8AqWEE/2vfPIQ../1700132556913.jpg"
      },
      "company_details": {
        "id": 653,
        "created_at": 1726461518385,
        "name_alias": "Comfort Click",
        "company_link": "https://www.comfortclick.co.uk/",
        "company_name": "Comfort Click",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/VBNsCsyFWygJdajcf64aylLe4Q8/oVz9Kw../Screenshot%2B2024-09-16%2Bat%2B10.07.10%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+10.07.10â€¯AM.png",
          "path": "/vault/OXY-0ZPV/VBNsCsyFWygJdajcf64aylLe4Q8/oVz9Kw../Screenshot%2B2024-09-16%2Bat%2B10.07.10%E2%80%AFAM.png",
          "size": 25302,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Human Resources Administrative Officer (Shared Services)",
      "skill_companies_id": 653
    },
    {
      "sort_order": 100,
      "user_details": {
        "name": "Muhsin Ahemmed",
        "linkedin_url": "https://www.linkedin.com/in/muhsinahemmed/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/7lsLBcDCvOTTijlx-SPzrMO8_Hk/Byrm2A../1730089685284.jpg"
      },
      "company_details": {
        "id": 611,
        "created_at": 1725887601947,
        "name_alias": "Brand bond company",
        "company_link": "https://www.linkedin.com/company/brand-bond-company/",
        "company_name": "Brand bond company",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/X0XuTn509lsWSN9hJughVyQtqwk/F_ggwA../1711614590848.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1711614590848.jpeg",
          "path": "/vault/OXY-0ZPV/X0XuTn509lsWSN9hJughVyQtqwk/F_ggwA../1711614590848.jpeg",
          "size": 3252,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Head of Digital Marketing",
      "skill_companies_id": 611
    },
    {
      "sort_order": 101,
      "user_details": {
        "name": "Sahil Choudhury",
        "linkedin_url": "https://www.linkedin.com/in/sahil-choudhury-5367ab124/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/XX26BU7s3WQ2Z63VCciID2VNiM4/FShxEA../1730802004624.jpg"
      },
      "company_details": {
        "id": 629,
        "created_at": 1726370881506,
        "name_alias": "OvalEdge",
        "company_link": "https://www.ovaledge.com/",
        "company_name": "OvalEdge",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/_k1hQUTX7ysnhVJ3DnZB-xj7N7M/59hFLQ../Screenshot%2B2024-09-15%2Bat%2B8.57.46%E2%80%AFAM.png",
          "meta": {
            "width": 160,
            "height": 168
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-15+at+8.57.46â€¯AM.png",
          "path": "/vault/OXY-0ZPV/_k1hQUTX7ysnhVJ3DnZB-xj7N7M/59hFLQ../Screenshot%2B2024-09-15%2Bat%2B8.57.46%E2%80%AFAM.png",
          "size": 19098,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Project Manager",
      "skill_companies_id": 629
    },
    {
      "sort_order": 102,
      "user_details": {
        "name": "Kartikey Rawat",
        "linkedin_url": "https://www.linkedin.com/in/kartikey-singh-rawat/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/qK7pEQfUXQN2TMUZOsqknaryfn8/e8FLFA../1719028010959.jpg"
      },
      "company_details": {
        "id": 646,
        "created_at": 1726460428748,
        "name_alias": "WNS",
        "company_link": "https://www.wns.com/",
        "company_name": "WNS",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/-1AmE0OExMKUZeKDG4Vd664SLQM/Z1GgKg../Screenshot%2B2024-09-16%2Bat%2B9.50.13%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.50.13â€¯AM.png",
          "path": "/vault/OXY-0ZPV/-1AmE0OExMKUZeKDG4Vd664SLQM/Z1GgKg../Screenshot%2B2024-09-16%2Bat%2B9.50.13%E2%80%AFAM.png",
          "size": 34345,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nLead Associate - Quality",
      "skill_companies_id": 646
    }
  ,
    {
      "sort_order": 103,
      "user_details": {
        "name": "Rayyan Khan",
        "linkedin_url": "https://www.linkedin.com/in/rayyan-khan-8b6326290/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/8i2tVcUBynJ4gIG1bUAYLB2SLAI/1XnbHQ../1725174975387.jpg"
      },
      "company_details": {
        "id": 630,
        "created_at": 1726371016593,
        "name_alias": "Pune StartUp Fest",
        "company_link": "https://www.punestartupfest.in/",
        "company_name": "Pune StartUp Fest",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/D2DzOwhPti6IUg5a99xkLin93bw/EwOQCQ../Screenshot%2B2024-09-15%2Bat%2B9.00.01%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 168
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-15+at+9.00.01â€¯AM.png",
          "path": "/vault/OXY-0ZPV/D2DzOwhPti6IUg5a99xkLin93bw/EwOQCQ../Screenshot%2B2024-09-15%2Bat%2B9.00.01%E2%80%AFAM.png",
          "size": 35199,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Public Relations Specialist",
      "skill_companies_id": 630
    },
    {
      "sort_order": 104,
      "user_details": {
        "name": "Kazi Riaz Hossen",
        "linkedin_url": "https://www.linkedin.com/in/kazi-riaz-hossen/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/JUpTJSLyxA0prWAbM2V0l8BgSOU/1RJFOg../1722861693321.jpg"
      },
      "company_details": {
        "id": 634,
        "created_at": 1726371710069,
        "name_alias": "Krishna Tech Creation",
        "company_link": "https://www.krishnatech.com/",
        "company_name": "Krishna Tech Creation",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/JkhiB0h4QgNxEcDVY2-onLAxp5Q/MbJuag../Screenshot%2B2024-09-15%2Bat%2B9.11.35%E2%80%AFAM.png",
          "meta": {
            "width": 182,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-15+at+9.11.35â€¯AM.png",
          "path": "/vault/OXY-0ZPV/JkhiB0h4QgNxEcDVY2-onLAxp5Q/MbJuag../Screenshot%2B2024-09-15%2Bat%2B9.11.35%E2%80%AFAM.png",
          "size": 17148,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nWeb Development Using AI Intern",
      "skill_companies_id": 634
    },
    {
      "sort_order": 105,
      "user_details": {
        "name": "Pramodita Sadhu",
        "linkedin_url": "https://www.linkedin.com/in/pramodita-sadhu-282296198/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/2mCsGVf02ON0wLKfaqhdObXJL9U/SIptbA../1726391337109.jpg"
      },
      "company_details": {
        "id": 481,
        "created_at": 1685718597684,
        "name_alias": "",
        "company_link": "https://www.youtube.com/c/cloudyML",
        "company_name": "CloudyML",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/AAjZjcEdm2w5ZHyiDFUNwCRwwIs/TUKgtg../image_2023-06-02_203946984.png",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/png",
          "name": "image_2023-06-02_203946984.png",
          "path": "/vault/OXY-0ZPV/AAjZjcEdm2w5ZHyiDFUNwCRwwIs/TUKgtg../image_2023-06-02_203946984.png",
          "size": 35259,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nSenior Manager",
      "skill_companies_id": 481
    },
    {
      "sort_order": 106,
      "user_details": {
        "name": "Aadhithya Rajan",
        "linkedin_url": "https://www.linkedin.com/in/aadhithya-rajan-9a91241a1/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/VSCN-v2R3eN-WbMJa9GlwCtdLKo/cLRQSQ../1667658269314.jpg"
      },
      "company_details": {
        "id": 596,
        "created_at": 1725881997821,
        "name_alias": "Ginger Technologies",
        "company_link": "https://gingertechnologies.in/",
        "company_name": "Ginger Technologies",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/tGCSJMjDb2aUmFC5B0CmltfSimY/pac-6g../gingertechnologies_logo.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "gingertechnologies_logo.jpeg",
          "path": "/vault/OXY-0ZPV/tGCSJMjDb2aUmFC5B0CmltfSimY/pac-6g../gingertechnologies_logo.jpeg",
          "size": 8660,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Front-End Developer",
      "skill_companies_id": 596
    },
    {
      "sort_order": 107,
      "user_details": {
        "name": "Ajay kumar Jaladanki",
        "linkedin_url": "https://www.linkedin.com/in/ajay-kumar-jaladanki/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ekXNoGVStObp_evdjgnvA2AM3bg/wjCmhQ../1725690862350.jpg"
      },
      "company_details": {
        "id": 689,
        "created_at": 1730778097922,
        "name_alias": "KJ SYSTEMS (INDIA) PRIVATE LIMITED",
        "company_link": "http://kjsystems.in/",
        "company_name": "KJ SYSTEMS (INDIA) PRIVATE LIMITED",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/RHuW4jlYcI-zLwzV9UvGSuyXZA8/e6ZGqg../26.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "26.jpeg",
          "path": "/vault/OXY-0ZPV/RHuW4jlYcI-zLwzV9UvGSuyXZA8/e6ZGqg../26.jpeg",
          "size": 8115,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Business Analyst",
      "skill_companies_id": 689
    },
    {
      "sort_order": 108,
      "user_details": {
        "name": "Tej Soni",
        "linkedin_url": "https://www.linkedin.com/in/tej-soni22/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/YZgsnoOUyBRPTjXeADrQn2dKrEM/knPWcg../1688241007240.jpg"
      },
      "company_details": {
        "id": 690,
        "created_at": 1730778156452,
        "name_alias": "Rysun Labs",
        "company_link": "https://www.rysun.com/",
        "company_name": "Rysun Labs",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Mp2LwBQStXcBYiAkApC1XY1IMcs/EhDh3Q../27.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "27.jpeg",
          "path": "/vault/OXY-0ZPV/Mp2LwBQStXcBYiAkApC1XY1IMcs/EhDh3Q../27.jpeg",
          "size": 6627,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Software Developer L1",
      "skill_companies_id": 690
    },
    {
      "sort_order": 109,
      "user_details": {
        "name": "Patil Shubham Ashok",
        "linkedin_url": "https://www.linkedin.com/in/patil-shubham-525b72262/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/N_IWAIgGAP9NIw5f_7-qDGy2Q4w/nTwTXQ../1726207141617.jpg"
      },
      "company_details": {
        "id": 425,
        "created_at": 1683696395825,
        "name_alias": "",
        "company_link": "http://www.sunpharma.com/",
        "company_name": "SUN PHARMA",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/OFLGHYBGE-nIhpwOfKgB34DiNE0/Mo1HDA../1636538768876.jpg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1636538768876.jpg",
          "path": "/vault/OXY-0ZPV/OFLGHYBGE-nIhpwOfKgB34DiNE0/Mo1HDA../1636538768876.jpg",
          "size": 8458,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Sales Executive",
      "skill_companies_id": 425
    },
    {
      "sort_order": 110,
      "user_details": {
        "name": "Saurav Pulyadath",
        "linkedin_url": "https://www.linkedin.com/in/saurav-pulyadath-b4a02712a/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/YlSHRC7Igvg_OIbz4JGuOCrtLY8/GNpl1w../1669286382131.jpg"
      },
      "company_details": {
        "id": 609,
        "created_at": 1725887374060,
        "name_alias": "Digital Regenesys",
        "company_link": "https://www.linkedin.com/company/digital-regenesys/about/",
        "company_name": "Digital Regenesys",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/YSSxf2aN7HxWB99TSA9hKoh1V5E/-rgN5g../1646910549207.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1646910549207.jpeg",
          "path": "/vault/OXY-0ZPV/YSSxf2aN7HxWB99TSA9hKoh1V5E/-rgN5g../1646910549207.jpeg",
          "size": 6661,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Manager - International Sales",
      "skill_companies_id": 609
    },
    {
      "sort_order": 111,
      "user_details": {
        "name": "Yash Solanki",
        "linkedin_url": "https://www.linkedin.com/in/yash-solanki-466514252/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/C1q7pjl7V71GpxB-QK7wMAaKPOs/6BQ9zg../1664679054952.jpg"
      },
      "company_details": {
        "id": 635,
        "created_at": 1726371804519,
        "name_alias": "EduTest Solutions",
        "company_link": "https://edu-test.in/",
        "company_name": "EduTest Solutions",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/plvYomAwDstIYo83Q-85QxRKZW0/vlej4A../Screenshot%2B2024-09-15%2Bat%2B9.13.06%E2%80%AFAM.png",
          "meta": {
            "width": 182,
            "height": 186
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-15+at+9.13.06â€¯AM.png",
          "path": "/vault/OXY-0ZPV/plvYomAwDstIYo83Q-85QxRKZW0/vlej4A../Screenshot%2B2024-09-15%2Bat%2B9.13.06%E2%80%AFAM.png",
          "size": 41948,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Associate in Command Center",
      "skill_companies_id": 635
    },
    {
      "sort_order": 112,
      "user_details": {
        "name": "Vighnesh Ganmale",
        "linkedin_url": "https://www.linkedin.com/in/vighnesh-ganmale-12707b2a2/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/oI06KbC5Y8qfQjhzJKEYtqQCP58/1Ol-NA../1701239816195.jpg"
      },
      "company_details": {
        "id": 691,
        "created_at": 1730778296504,
        "name_alias": "Daifuku Intralogistics India Pvt. Ltd.",
        "company_link": "https://www.daifuku.com/company/groupcompanies/india-intralogistics",
        "company_name": "Daifuku Intralogistics India Pvt. Ltd.",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/vIhqU1D2aPD9B1JJwJxAH_l4sSo/q2HZFA../28.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "28.jpeg",
          "path": "/vault/OXY-0ZPV/vIhqU1D2aPD9B1JJwJxAH_l4sSo/q2HZFA../28.jpeg",
          "size": 4016,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Java Developer",
      "skill_companies_id": 691
    }
  ,
    {
      "sort_order": 113,
      "user_details": {
        "name": "Ashwin S",
        "linkedin_url": "https://www.linkedin.com/in/ashwin-sethupathiselvaraj-9b2b38267/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/6JXA73Hugngp8pgM_pc_UZQpWmk/m10cXg../1721934911532.jpg"
      },
      "company_details": {
        "id": 692,
        "created_at": 1730778375373,
        "name_alias": "Mount Zion International School",
        "company_link": "https://mountzionschools.com/cbse",
        "company_name": "Mount Zion International School",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/0gwNY37iKzR00nkA8oTEFFUOdio/eEPb5A../30.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "30.jpeg",
          "path": "/vault/OXY-0ZPV/0gwNY37iKzR00nkA8oTEFFUOdio/eEPb5A../30.jpeg",
          "size": 12197,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Work education mentor",
      "skill_companies_id": 692
    },
    {
      "sort_order": 114,
      "user_details": {
        "name": "Mounika Tarala",
        "linkedin_url": "https://www.linkedin.com/in/mounika-tarala-651834144/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/MwfPT1vozQMQ69p3QsSJk8EGiK4/PHz7vA../1722819207552.jpg"
      },
      "company_details": {
        "id": 47,
        "created_at": 1661988815622,
        "name_alias": "alias name needed",
        "company_link": "https://www.genpact.com/careers",
        "company_name": "Genpact",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1719928740495.jpeg",
          "path": "/vault/OXY-0ZPV/8yh0wc5yOlm8UJgzktxFkq6iWHU/Pn61Bg../1719928740495.jpeg",
          "size": 5159,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nProcess Associate",
      "skill_companies_id": 47
    },
    {
      "sort_order": 115,
      "user_details": {
        "name": "Abhishek Chaudhary",
        "linkedin_url": "https://www.linkedin.com/in/abhishek-chaudhary-754800237/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/p8xW47u9L9mrg6pRWnJS-QTbV0Q/DfUJsw../1731075011286.jpg"
      },
      "company_details": {
        "id": 638,
        "created_at": 1726459463114,
        "name_alias": "Planet EDU",
        "company_link": "https://www.theplanetedu.com/",
        "company_name": "Planet EDU",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/X4Ds6iIOg6BOZ4EB95U2ekWpIww/XOs6Rw../Screenshot%2B2024-09-16%2Bat%2B9.34.10%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.34.10â€¯AM.png",
          "path": "/vault/OXY-0ZPV/X4Ds6iIOg6BOZ4EB95U2ekWpIww/XOs6Rw../Screenshot%2B2024-09-16%2Bat%2B9.34.10%E2%80%AFAM.png",
          "size": 20667,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Operations Executive",
      "skill_companies_id": 638
    },
    {
      "sort_order": 116,
      "user_details": {
        "name": "Mohammed Sami Nadaf",
        "linkedin_url": "https://www.linkedin.com/in/mohammed-sami-nadaf-39a781327/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Dp8TJJ3oNliTZ6NvcW1S-mZ_HnA/7Zki9A../1725547342291.jpg"
      },
      "company_details": {
        "id": 649,
        "created_at": 1726460715857,
        "name_alias": "MicroTech FuSa Solutions",
        "company_link": "https://www.microtechfusasolutions.com/",
        "company_name": "MicroTech FuSa Solutions",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/r8dUCSDsFwQg1TYNEj-H5k2B3AQ/rLsneA../Screenshot%2B2024-09-16%2Bat%2B9.54.38%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+9.54.38â€¯AM.png",
          "path": "/vault/OXY-0ZPV/r8dUCSDsFwQg1TYNEj-H5k2B3AQ/rLsneA../Screenshot%2B2024-09-16%2Bat%2B9.54.38%E2%80%AFAM.png",
          "size": 20164,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "\nTrainee",
      "skill_companies_id": 649
    },
    {
      "sort_order": 117,
      "user_details": {
        "name": "Pallavi K M",
        "linkedin_url": "https://www.linkedin.com/in/pallavi-k-m-0170792b9/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/wJFmeu0Nhzcrvf4iRmV2hYW_Uhg/24lB0g../1721914623139.jpg"
      },
      "company_details": {
        "id": 657,
        "created_at": 1726462188915,
        "name_alias": "Scontinent Technologies Pvt Ltd",
        "company_link": "http://studentcontinent.in/",
        "company_name": "Scontinent Technologies Pvt Ltd",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/rfku6QjjCT-zpGTMMCJpk9xt7dk/lSj0pg../Screenshot%2B2024-09-16%2Bat%2B10.19.23%E2%80%AFAM.png",
          "meta": {
            "width": 192,
            "height": 194
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-16+at+10.19.23â€¯AM.png",
          "path": "/vault/OXY-0ZPV/rfku6QjjCT-zpGTMMCJpk9xt7dk/lSj0pg../Screenshot%2B2024-09-16%2Bat%2B10.19.23%E2%80%AFAM.png",
          "size": 35618,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Full stack developer intern",
      "skill_companies_id": 657
    },
    {
      "sort_order": 118,
      "user_details": {
        "name": "Ayush Vaishya",
        "linkedin_url": "https://www.linkedin.com/in/ayush-vaishya/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/EOd2aSBjGXn-s3w7e7C6IPE8XvI/PmqTmA../1726318668171.jpg"
      },
      "company_details": {
        "id": 633,
        "created_at": 1726371536142,
        "name_alias": "Adani Ports and SEZ",
        "company_link": "https://www.adaniports.com/",
        "company_name": "Adani Ports and SEZ",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/TRolzR3Bga7aq7f101JpnJgdNgI/SfHY6w../Screenshot%2B2024-09-15%2Bat%2B9.08.41%E2%80%AFAM.png",
          "meta": {
            "width": 176,
            "height": 174
          },
          "mime": "image/png",
          "name": "Screenshot+2024-09-15+at+9.08.41â€¯AM.png",
          "path": "/vault/OXY-0ZPV/TRolzR3Bga7aq7f101JpnJgdNgI/SfHY6w../Screenshot%2B2024-09-15%2Bat%2B9.08.41%E2%80%AFAM.png",
          "size": 17313,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Operational Lead / Duty Shift Officer & Data analyst in |Integrated Security Control Room|",
      "skill_companies_id": 633
    },
    {
      "sort_order": 119,
      "user_details": {
        "name": "SIDDHARTH SWAIN",
        "linkedin_url": "https://www.linkedin.com/in/siddharth-swain-847200223/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/OuhiJOo-gdx9axCN9YbyQhRaaCo/C4RmJA../1730835139324.jpg"
      },
      "company_details": {
        "id": 671,
        "created_at": 1730776622499,
        "name_alias": "Gigfactory",
        "company_link": "https://www.gigfactory.in/",
        "company_name": "Gigfactory",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/YSWKh39e-Wst7a8VgOsJ2-k_QyU/bun5vw../8.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "8.jpeg",
          "path": "/vault/OXY-0ZPV/YSWKh39e-Wst7a8VgOsJ2-k_QyU/bun5vw../8.jpeg",
          "size": 3521,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Business Development Representative",
      "skill_companies_id": 671
    },
    {
      "sort_order": 120,
      "user_details": {
        "name": "Shreya k",
        "linkedin_url": "https://www.linkedin.com/in/shreya-k-3ba455267/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/x2-9_91axa6C4xTn1ssWhZHrlUk/_i5sxA../1729152625982.jpg"
      },
      "company_details": {
        "id": 664,
        "created_at": 1730775962455,
        "name_alias": "Jobtrix | Powered by Kyla",
        "company_link": "https://jobtrix.in/",
        "company_name": "Jobtrix | Powered by Kyla",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Dlh1pYTJSPcRvjsM-nZQRTvSIZk/0YNS8A../1.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "1.jpeg",
          "path": "/vault/OXY-0ZPV/Dlh1pYTJSPcRvjsM-nZQRTvSIZk/0YNS8A../1.jpeg",
          "size": 4447,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Senior Talent Acquisition Specialist",
      "skill_companies_id": 664
    },
    {
      "sort_order": 121,
      "user_details": {
        "name": "Shaik Masthan Basha",
        "linkedin_url": "https://www.linkedin.com/in/masthan-basha-a8a526232/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/MUvgykZbzzdIgJz0RgQMoklt6Yw/01B9-g../1722705633390.jpg"
      },
      "company_details": {
        "id": 668,
        "created_at": 1730776424128,
        "name_alias": "Movate",
        "company_link": "https://www.movate.com/",
        "company_name": "Movate",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/pqmyfg5yJM7F7hktPXN1zd2tut0/reJhqw../5.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "5.jpeg",
          "path": "/vault/OXY-0ZPV/pqmyfg5yJM7F7hktPXN1zd2tut0/reJhqw../5.jpeg",
          "size": 4877,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Engineer",
      "skill_companies_id": 668
    },
    {
      "sort_order": 122,
      "user_details": {
        "name": "Arshiya Vohra",
        "linkedin_url": "https://www.linkedin.com/in/arshiya-vohra-226634225/",
        "profile_image": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/1gEXT88T8I7cEvIbP0Y_eorjAds/bAF0lQ../1713953848036.jpg"
      },
      "company_details": {
        "id": 670,
        "created_at": 1730776560992,
        "name_alias": "Taj Hotels",
        "company_link": "http://www.tajhotels.com/",
        "company_name": "Taj Hotels",
        "company_image": {
          "url": "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/LWexsqtM7hlhtACCA7ifsFBAFLc/tJMCYg../7.jpeg",
          "meta": {
            "width": 200,
            "height": 200
          },
          "mime": "image/jpeg",
          "name": "7.jpeg",
          "path": "/vault/OXY-0ZPV/LWexsqtM7hlhtACCA7ifsFBAFLc/tJMCYg../7.jpeg",
          "size": 3413,
          "type": "image",
          "access": "public"
        },
        "company_image_square": null
      },
      "job_designation": "Guest Service Associate",
      "skill_companies_id": 670
    }
  ]
  
  